import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db, auth, storage } from "../../firebase.init";
import { collection, query, where, getDocs, doc, updateDoc, setDoc, getDoc, deleteDoc, addDoc, serverTimestamp, collectionGroup, orderBy } from "firebase/firestore";
import "./Review.css";
import defaultImage from '../Assets/default.png';
import { Modal, Button, Form, Row, Col, Tabs, Tab, Card, InputGroup, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPoundSign } from "@fortawesome/free-solid-svg-icons";
import ClipLoader from "react-spinners/ClipLoader";
import { useAuthState } from 'react-firebase-hooks/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { faTrash, faCircleCheck, faArchive, faUndo, faCheck, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { ref, deleteObject, listAll, uploadString, getDownloadURL } from "firebase/storage";
import AnnotateModal from "../AnnotateModal/AnnotateModal"
import { useUserRole } from '../../hooks/useUserRole';

const Review = ({ directReport = null, directOpen = false, onDirectClose } = {}) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [formData, setFormData] = useState({
    doorDimWidth: "",
    doorDimHeight: "",
    doorDimDepth: "",
    doorLevel: "",
    doorLocation: "",
    doorUsage: "",
    closerType: "",
    stripType: "",
    frameMaterial: "Wood",
    doorCertif: "",
    fD1: "",
    fD2: "",
    fD3: "",
    fD4: "",
    doorCloseAsIntented: null,
    doorStrips: null,
    hingesWorking: null,
    hingesFireRating: null,
    lockFireRated: null,
    keylessExit: null,
    letterBoxFireRated: null,
    relevantSignage: true,
    damageMultiples: {
      door: "door Pass",
      frame: "frame Pass",
      glass: "glass Pass",
      ventilation: "ventilation Pass",
    },
    workNeededSelections: {
      door: "",
      frame: "",
      glass: "",
      ventilation: "",
    },
  });
  const scrollPositionRef = useRef(0);

  const userData = useUserRole();
  const { role, uid, user: currentUser } = userData;

  const navigate = useNavigate();
  const { buildingId, id } = useParams();

  const isDeepLinkRef = useRef(Boolean(buildingId && id));
  const isDeepLink = isDeepLinkRef.current;

  const [zoomedImage, setZoomedImage] = useState(null);
  const [zoomedVideo, setZoomedVideo] = useState(null);

  const [activeTab, setActiveTab] = useState('review');
  const [prices, setPrices] = useState({});
  const [originalPrices, setOriginalPrices] = useState({});
  const [saveStatus, setSaveStatus] = useState(null);
  const [laborCost, setLaborCost] = useState("");
  const [includeVAT, setIncludeVAT] = useState(false);
  const [includeManagementFee, setIncludeManagementFee] = useState(false);
  const [originalLaborCost, setOriginalLaborCost] = useState("");
  const [originalIncludeVAT, setOriginalIncludeVAT] = useState(false);
  const [originalIncludeManagementFee, setOriginalIncludeManagementFee] = useState(false);
  const [unlockedTabs, setUnlockedTabs] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const [buildingFilter, setBuildingFilter] = useState('');
  const [buildingArchiveFilter, setBuildingArchiveFilter] = useState('');
  const [buildingFinalReviewFilter, setBuildingFinalReviewFilter] = useState('');

  const [selectedPreset, setSelectedPreset] = useState(null);
  const [defaultValues, setDefaultValues] = useState({});
  const [user, loadingAuth] = useAuthState(auth);
  const [activePresetTab, setPresetActiveTab] = useState("1");
  const [presetData, setPresetData] = useState({
    1: {},
    2: {},
    3: {},
  });
  const [showPresetModal, setShowPresetModal] = useState(false);
  const [show, setShow] = useState(false);
  const [aiResult, setAiResult] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);

  const [showDamageModal, setShowDamageModal] = useState(false);
  // const [activeMedia, setActiveMedia] = useState({ src: "", isVideo: false, label: "" });

  const [sortOption, setSortOption] = useState("dateDesc");
  const sortOptions = [
    { value: "dateDesc", label: "Date: Latest First" },
    { value: "dateAsc", label: "Date: Oldest First" },
    { value: "doorDesc", label: "Door Number: High → Low" },
    { value: "doorAsc", label: "Door Number: Low → High" },
    { value: "certAsc", label: "Cert: FD30 → FD60" },
    { value: "certDesc", label: "Cert: FD60 → FD30" },
  ];

  const [certFilter, setCertFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  const [certArchiveFilter, setArchiveCertFilter] = useState("");
  const [dateArchiveFilter, setArchiveDateFilter] = useState("");

  const [certFinalReviewFilter, setFinalReviewCertFilter] = useState("");
  const [dateFinalReviewFilter, setFinalReviewDateFilter] = useState("");

  const [viewMode, setViewMode] = useState("review");
  const [archivedReports, setArchivedReports] = useState([]);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [showUnarchiveModal, setShowUnarchiveModal] = useState(false);
  const [selectedArchiveReport, setSelectedArchiveReport] = useState(null);
  const [showArchiveConfirmModal, setShowArchiveConfirmModal] = useState(false);

  const [finalReviewReports, setFinalReviewReports] = useState([]);
  const [showFinalConfirmModal, setShowFinalConfirmModal] = useState(false);
  const [selectedFinalReport, setSelectedFinalReport] = useState(null);

  const [showSendBackModal, setShowSendBackModal] = useState(false);
  const [selectedSendBackReport, setSelectedSendBackReport] = useState(null);

  const [pageLoading, setPageLoading] = useState(false);
  const [loadedPageImages, setLoadedPageImages] = useState(0);

  const [pages, setPages] = useState({
    review: 1,
    finalReview: 1,
    archive: 1,
  });

  const [itemsPerPage, setItemsPerPage] = useState(48);

  const currentPage = pages[viewMode] || 1;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handlePageChange = (page) => {
    if (pageLoading) return;

    const validPage = Math.max(1, Math.min(page, totalPages));

    if (validPage === currentPage) return;

    setPageLoading(true);
    setLoadedPageImages(0);

    setPages((previousPages) => ({
      ...previousPages,
      [viewMode]: validPage,
    }));
  };

  const handleItemsPerPageChange = (value) => {
    setItemsPerPage(value);

    setPages({
      review: 1,
      finalReview: 1,
      archive: 1,
    });
  };

  const uniqueBuildings = useMemo(() => {
    const map = new Map();
    reports.forEach((r) => {
      if (r.buildingId && !map.has(r.buildingId)) {
        map.set(r.buildingId, r.buildingName || "Unknown");
      }
    });
    return Array.from(map.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [reports]);

  const uniqueArchiveBuildings = useMemo(() => {
    const map = new Map();
    archivedReports.forEach((r) => {
      if (r.buildingId && !map.has(r.buildingId)) {
        map.set(r.buildingId, r.buildingName || "Unknown");
      }
    });
    return Array.from(map.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [archivedReports]);

  const uniqueFinalReviewBuildings = useMemo(() => {
    const map = new Map();
    finalReviewReports.forEach((r) => {
      if (r.buildingId && !map.has(r.buildingId)) {
        map.set(r.buildingId, r.buildingName || "Unknown");
      }
    });
    return Array.from(map.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [finalReviewReports]);

  const uniqueCerts = [...new Set(reports.map(r => r.doorCertif).filter(Boolean))];
  const uniqueDates = [...new Set(reports.map(r => r.date.split(" ")[0]).filter(Boolean))]
    .map(date => ({
      value: date,
      label: formatDate(date)
    }));

  const uniqueArchiveCerts = [...new Set(archivedReports.map(r => r.doorCertif).filter(Boolean))];
  const uniqueArchiveDates = [...new Set(archivedReports.map(r => r.date.split(" ")[0]).filter(Boolean))]
    .map(date => ({
      value: date,
      label: formatDate(date)
    }));

  const uniqueFinalReviewCerts = [...new Set(finalReviewReports.map(r => r.doorCertif).filter(Boolean))];
  const uniqueFinalReviewDates = [...new Set(finalReviewReports.map(r => r.date?.split(" ")[0]).filter(Boolean))]
    .map(date => ({
      value: date,
      label: formatDate(date)
    }));

  const emptyPreset = {
    doorDimWidth: "",
    doorDimHeight: "",
    doorDimDepth: "",
    doorLevel: "",
    doorLocation: "",
    doorUsage: "",
    frameMaterial: "",
    doorCertif: "",
    fD1: "",
    fD2: "",
    fD3: "",
    fD4: "",

    doorCloseAsIntented: null,
    doorStrips: null,
    hingesWorking: null,
    hingesFireRating: null,
    lockFireRated: null,
    keylessExit: null,
    letterBoxFireRated: null,
    relevantSignage: null,

    damageMultiples: {
      door: "door Pass",
      frame: "frame Pass",
      glass: "glass Pass",
      ventilation: "ventilation Pass",
    },

    workNeededSelections: {
      door: "",
      frame: "",
      glass: "",
      ventilation: "",
    },
  };

  const fieldDropdowns = {
    doorCloseAsIntented: ["Repair Door Closer", "Adjust Door Closer", "Install New Door Closer", "Replace Door Closer"],
    doorStrips: ["Install Intumescent Strips", "Replace Damaged Intumescent Strip", "Replace Missing Intumescent Strip", "Intumescent Strip Installed Incorrectly"],
    hingesWorking: ["Screws Missing From Hinge", "Tighten Hinge", "Install Third Fire Rated Hinge", "Replace Broken Hinge"],
    hingesFireRating: ["Replace Non-Compliant Hinge"],
    lockFireRated: ["Replace Non-Compliant Locks"],
    keylessExit: ["Install Keyless Exit"],
    letterBoxFireRated: ["Upgrade Non-Compliant LetterBox"],
    relevantSignage: ["Install Relevant Signage"],

    door: ["Replace Damaged Door", "Repair Damaged Door", "Replace Non-Compliant Door", "Other (Door)"],
    frame: ["Repair Damaged Door Frame", "Replace damaged door frame", "Other (Frame)"],
    glass: ["Replace Cracked Glass", "Replace Non-Compliant Glass", "Refix Loose Glazing Beads", "Replace Glazing Beads", "Other (Glass)"],
    ventilation: ["Clear Blocked Ventilation Gaps", "Install Additional Gaps If Needed", "Other (Ventilation)"],
  };

  function getOrdinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function generateFloors() {
    const floors = [];

    for (let i = 1; i <= 2; i++) {
      floors.push(`Basement ${i}`);
    }

    floors.push("Ground Floor");
    floors.push("Mezzanine");

    for (let i = 1; i <= 62; i++) {
      floors.push(`${getOrdinal(i)} Floor`);
    }

    return floors;
  }

  const [showManualAnnotateModal, setShowManualAnnotateModal] = useState(false);
  const [showAnnotateModalResult, setShowAnnotateModalResult] = useState("");
  const [currentAnnotatingDoor, setCurrentAnnotatingDoor] = useState(null);

  useEffect(() => {
    if (!loading) {
      window.scrollTo(0, scrollPositionRef.current);
    }
  }, [loading]);


  const buildingNameMapRef = useRef(null);

  const getBuildingNameMap = async () => {
    if (buildingNameMapRef.current) return buildingNameMapRef.current;

    const reportsSnapshot = await getDocs(collection(db, "Reports"));
    const map = {};
    reportsSnapshot.docs.forEach((doc) => {
      map[doc.id] = doc.data().buildingName || "Unknown";
    });
    buildingNameMapRef.current = map;
    return map;
  };

  const fetchReports = async () => {
    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
    setLoading(true);
    try {
      const buildingNameMap = await getBuildingNameMap();

      const [doorSnapshot, residentialSnapshot] = await Promise.all([
        getDocs(
          query(
            collectionGroup(db, "DoorReports"),
            where("requiresReview", "==", true),
            orderBy("date", "desc")
          )
        ),
        getDocs(
          query(
            collectionGroup(db, "ResidentialReports"),
            where("requiresReview", "==", true),
            orderBy("date", "desc")
          )
        ),
      ]);

      const mapDocs = (snapshot, type) =>
        snapshot.docs.map((doc) => {
          const buildingId = doc.ref.parent.parent.id;
          return {
            id: doc.id,
            buildingId,
            buildingName: buildingNameMap[buildingId] || "Unknown",
            type,
            ...doc.data(),
          };
        });

      const doorReports = mapDocs(doorSnapshot, "communal").filter((r) => !r.archived);
      const residentialReports = mapDocs(residentialSnapshot, "residential").filter((r) => !r.archived);

      const needsReview = mergeSortedByDate(doorReports, residentialReports);

      setReports(needsReview);
      setFinalReviewReports([]);
    } catch (error) {
      console.error("Error fetching review reports:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchArchivedReports = async () => {
    setArchiveLoading(true);
    try {
      const buildingNameMap = await getBuildingNameMap();

      const [doorSnapshot, residentialSnapshot] = await Promise.all([
        getDocs(
          query(
            collectionGroup(db, "DoorReports"),
            where("archived", "==", true),
            orderBy("date", "desc")
          )
        ),
        getDocs(
          query(
            collectionGroup(db, "ResidentialReports"),
            where("archived", "==", true),
            orderBy("date", "desc")
          )
        ),
      ]);

      const mapDocs = (snapshot, type) =>
        snapshot.docs.map((doc) => {
          const buildingId = doc.ref.parent.parent.id;
          return {
            id: doc.id,
            buildingId,
            buildingName: buildingNameMap[buildingId] || "Unknown",
            type,
            ...doc.data(),
          };
        });

      const doorReports = mapDocs(doorSnapshot, "communal");
      const residentialReports = mapDocs(residentialSnapshot, "residential");

      const allArchived = mergeSortedByDate(doorReports, residentialReports);

      setArchivedReports(allArchived);
    } catch (error) {
      console.error("Error fetching archived reports:", error);
    } finally {
      setArchiveLoading(false);
    }
  };

  function mergeSortedByDate(a, b) {
    const result = [];
    let i = 0, j = 0;
    while (i < a.length && j < b.length) {
      result.push(new Date(a[i].date) >= new Date(b[j].date) ? a[i++] : b[j++]);
    }
    while (i < a.length) result.push(a[i++]);
    while (j < b.length) result.push(b[j++]);
    return result;
  }

  const loadPresets = async () => {
    if (!user?.uid) return;
    const newPresetData = {};

    for (let i = 1; i <= 3; i++) {
      const docRef = doc(db, `users/${user.uid}/presets/${i}`);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        newPresetData[i] = docSnap.data();
      }
    }

    setPresetData(newPresetData);
  };

  const hasFetchedListRef = useRef(false);

  useEffect(() => {
    if (directOpen) {
      loadPresets();
      return;
    }

    loadPresets();

    if (hasFetchedListRef.current) return;
    hasFetchedListRef.current = true;

    fetchReports();
    fetchArchivedReports();
  }, [user, loadingAuth, directOpen]);

  const handleArchiveClick = (e, report) => {
    e.stopPropagation();
    setSelectedReport(report);
    setShowArchiveConfirmModal(true);
  };

  const handleConfirmArchive = async () => {
    if (!selectedReport) return;
    try {
      const collectionName = selectedReport.type === "residential"
        ? "ResidentialReports"
        : "DoorReports";
      const docRef = doc(
        db,
        `Reports/${selectedReport.buildingId}/${collectionName}/${selectedReport.id}`
      );
      await updateDoc(docRef, {
        archived: true,
      });
      setShowArchiveConfirmModal(false);
      setSelectedReport(null);
      fetchReports();
      fetchArchivedReports();
      openedKeyRef.current = null;
      goBack();
    } catch (error) {
      console.error("Error archiving report:", error);
    }
  };

  const handleUnarchiveClick = (e, report) => {
    e.stopPropagation();
    setSelectedArchiveReport(report);
    setShowUnarchiveModal(true);
  };

  const handleConfirmUnarchive = async () => {
    if (!selectedArchiveReport) return;
    try {
      const collectionName = selectedArchiveReport.type === "residential"
        ? "ResidentialReports"
        : "DoorReports";
      const docRef = doc(
        db,
        `Reports/${selectedArchiveReport.buildingId}/${collectionName}/${selectedArchiveReport.id}`
      );
      await updateDoc(docRef, {
        archived: false,
      });
      setShowUnarchiveModal(false);
      setSelectedArchiveReport(null);
      fetchReports();
      fetchArchivedReports();
    } catch (error) {
      console.error("Error unarchiving report:", error);
    }
  };

  const handleFinalReviewConfirmClick = (e, report) => {
    e.stopPropagation();
    setSelectedFinalReport(report);
    setShowFinalConfirmModal(true);
  };

  const handleConfirmFinalReview = async () => {
    if (!selectedFinalReport) return;

    const { buildingId, id, type } = selectedFinalReport;
    const collectionType = type === "residential" ? "ResidentialReports" : "DoorReports";

    try {
      setArchiveLoading(true);
      const docRef = doc(db, `Reports/${buildingId}/${collectionType}/${id}`);
      await updateDoc(docRef, { requiresReview: false, requiresFinalReview: false });

      setFinalReviewReports((prev) => prev.filter((r) => r.id !== id));
    } catch (error) {
      console.error("Error confirming final review:", error);
    } finally {
      setArchiveLoading(false);
      setShowFinalConfirmModal(false);
      setSelectedFinalReport(null);
    }
  };

  const handleSendBackClick = (event, report) => {
    event.preventDefault();
    event.stopPropagation();

    setSelectedSendBackReport(report);
    setShowSendBackModal(true);
  };

  const handleConfirmSendBackToReview = async () => {
    if (!selectedSendBackReport) return;

    const { buildingId, id, type } = selectedSendBackReport;

    if (!buildingId || !id) return;

    const collectionType =
      type === "residential"
        ? "ResidentialReports"
        : "DoorReports";

    try {
      setArchiveLoading(true);

      const docRef = doc(
        db,
        `Reports/${buildingId}/${collectionType}/${id}`
      );

      await updateDoc(docRef, {
        requiresReview: true,
        requiresFinalReview: false,
      });

      setFinalReviewReports((previousReports) =>
        previousReports.filter((item) => item.id !== id)
      );

      setReports((previousReports) => {
        const alreadyExists = previousReports.some(
          (item) => item.id === id
        );

        if (alreadyExists) {
          return previousReports.map((item) =>
            item.id === id
              ? {
                ...item,
                ...selectedSendBackReport,
                requiresReview: true,
                requiresFinalReview: false,
              }
              : item
          );
        }

        return [
          {
            ...selectedSendBackReport,
            requiresReview: true,
            requiresFinalReview: false,
          },
          ...previousReports,
        ];
      });
    } catch (error) {
      console.error("Error sending report back to review:", error);
    } finally {
      setArchiveLoading(false);
      setShowSendBackModal(false);
      setSelectedSendBackReport(null);
    }
  };

  const handleSavePreset = async (presetNumber) => {
    if (!user?.uid) return;

    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
    setLoading(true);

    try {
      const presetToSave = { ...presetData[presetNumber] } || {};

      const allowedKeys = [
        "door",
        "frame",
        "glass",
        "ventilation",
        "doorCloseAsIntented",
        "doorStrips",
        "hingesWorking",
        "hingesFireRating",
        "lockFireRated",
        "keylessExit",
        "letterBoxFireRated",
        "relevantSignage",
      ];

      const filteredWorkNeededSelections = {};
      allowedKeys.forEach((key) => {
        filteredWorkNeededSelections[key] =
          presetToSave.workNeededSelections?.[key] ?? "";
      });
      presetToSave.workNeededSelections = filteredWorkNeededSelections;

      const expectedFields = [
        "doorDimWidth",
        "doorDimHeight",
        "doorDimDepth",
        "doorCertif",
        "fD1",
        "fD2",
        "fD3",
        "fD4",
        "doorLevel",
        "doorLocation",
        "doorUsage",
        "frameMaterial",
        "doorCloseAsIntented",
        "doorStrips",
        "hingesWorking",
        "hingesFireRating",
        "lockFireRated",
        "keylessExit",
        "letterBoxFireRated",
        "relevantSignage",
      ];

      expectedFields.forEach((field) => {
        if (presetToSave[field] === undefined) {
          const isBool = ["doorCloseAsIntented", "doorStrips", "hingesWorking", "hingesFireRating", "lockFireRated", "keylessExit", "letterBoxFireRated", "relevantSignage"].includes(
            field
          );
          presetToSave[field] = isBool ? null : "";
        }
      });

      const damageKeys = ["door", "frame", "glass", "ventilation"];

      presetToSave.damageMultiples = presetToSave.damageMultiples || {};

      damageKeys.forEach((key) => {
        let label = key.charAt(0).toUpperCase() + key.slice(1);
        if (key === "ventilation") label = "Ventilation Gaps";

        const currentValue = presetToSave.damageMultiples[key] || "";

        let suffix = "Pass";
        if (currentValue.includes("None")) suffix = "None";
        else if (currentValue === label) suffix = "Fail";

        presetToSave.damageMultiples[key] =
          suffix === "Fail" ? label : `${label} ${suffix}`;
      });

      await setDoc(doc(db, `users/${user.uid}/presets/${presetNumber}`), presetToSave);

      toast.success(`Preset ${presetNumber} saved successfully!`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to save preset");
    } finally {
      setLoading(false);
    }
  };

  const fetchMissingDimensions = async (report) => {
    if (report.doorDimWidth && report.doorDimHeight && report.doorDimDepth
      && report.doorLevel && report.doorUsage && report.doorLocation) {
      return {};
    }

    const loadingMessages = [
      "",
    ];

    setMessageIndex(0);
    setCharIndex(0);
    setMessages(loadingMessages);
    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
    setLoading(true);

    const totalDelay = loadingMessages.reduce((sum, msg) => sum + msg.length * 40 + 1000, 0);
    await new Promise(res => setTimeout(res, totalDelay));

    const reportsCollection = collection(db, "Reports");
    const reportsSnapshot = await getDocs(reportsCollection);

    const matchingBuildings = reportsSnapshot.docs
      .map((doc) => ({
        buildingId: doc.id,
        buildingName: doc.data().buildingName,
        date: new Date(doc.data().date),
      }))
      .filter((r) => r.buildingName === report.buildingName)
      .sort((a, b) => a.date - b.date);

    if (matchingBuildings.length < 2) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);

      return {
        doorDimWidth: "0",
        doorDimHeight: "0",
        doorDimDepth: "0",
        doorUsage: "",
        frameMaterial: "",
        doorLevel: "",
        doorLocation: "",
      };
    }

    const secondMostRecent = matchingBuildings[matchingBuildings.length - 2];
    const collectionName = report.type === "communal" ? "DoorReports" : "ResidentialReports";

    const reportSnapshot = await getDocs(
      collection(db, `Reports/${secondMostRecent.buildingId}/${collectionName}`)
    );

    const matchedDoor = reportSnapshot.docs
      .map((doc) => doc.data())
      .find((r) => r.doorNumber === report.doorNumber);

    setTimeout(() => {
      setLoading(false);
    }, 2000);

    return {
      doorDimWidth: matchedDoor?.doorDimWidth || "0",
      doorDimHeight: matchedDoor?.doorDimHeight || "0",
      doorDimDepth: matchedDoor?.doorDimDepth || "0",
      doorUsage: matchedDoor?.doorUsage || "",
      doorLevel: matchedDoor?.doorLevel || "",
      doorLocation: matchedDoor?.doorLocation || "",
    };
  };

  const handleDeleteClick = (e, report) => {
    e.stopPropagation();
    setSelectedReport(report);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedReport) return;

    try {
      setLoading(true);

      const collectionName =
        selectedReport.type === "communal" ? "DoorReports" : "ResidentialReports";

      const docRef = doc(
        db,
        "Reports",
        selectedReport.buildingId,
        collectionName,
        selectedReport.doorId
      );
      await deleteDoc(docRef);

      const folderRef = ref(
        storage,
        `Reports/${selectedReport.buildingId}/${collectionName}/${selectedReport.doorId}`
      );

      const folderContents = await listAll(folderRef);
      if (folderContents.items.length > 0) {
        await Promise.all(folderContents.items.map((itemRef) => deleteObject(itemRef)));
      }

      const isArchived = archivedReports.some((r) => r.doorId === selectedReport.doorId);

      if (isArchived) {
        setArchivedReports((prev) => prev.filter((r) => r.doorId !== selectedReport.doorId));
      } else {
        setReports((prev) => prev.filter((r) => r.doorId !== selectedReport.doorId));
      }

      setShowDeleteModal(false);
      setSelectedReport(null);
      openedKeyRef.current = null;
      goBack();
    } catch (error) {
      console.error("Error deleting report and images:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSingleReport = async (buildingId, id) => {
    try {
      const buildingDocRef = doc(db, "Reports", buildingId);
      const buildingDocSnap = await getDoc(buildingDocRef);
      const buildingName = buildingDocSnap.exists()
        ? buildingDocSnap.data().buildingName || "Unknown"
        : "Unknown";

      const doorRef = doc(db, `Reports/${buildingId}/DoorReports/${id}`);
      const doorSnap = await getDoc(doorRef);
      if (doorSnap.exists()) {
        return {
          id: doorSnap.id,
          buildingId,
          buildingName,
          type: "communal",
          ...doorSnap.data(),
        };
      }

      const residentialRef = doc(db, `Reports/${buildingId}/ResidentialReports/${id}`);
      const residentialSnap = await getDoc(residentialRef);
      if (residentialSnap.exists()) {
        return {
          id: residentialSnap.id,
          buildingId,
          buildingName,
          type: "residential",
          ...residentialSnap.data(),
        };
      }

      return null;
    } catch (error) {
      console.error("Error fetching single report:", error);
      return null;
    }
  };

  const openedKeyRef = useRef(null);

  useEffect(() => {
    if (directOpen) return;
    if (!buildingId || !id) return;

    const key = `${buildingId}_${id}`;
    if (openedKeyRef.current === key) return;

    let cancelled = false;
    (async () => {
      try {
        const single = await fetchSingleReport(buildingId, id);
        if (cancelled) return;

        openedKeyRef.current = key;
        if (single) {
          openReportModal(single);
        } else {
          console.error("Review: no report found for", buildingId, id);
          setShowModal(false);
          openedKeyRef.current = null;
        }
      } catch (err) {
        if (cancelled) return;
        console.error("Review: failed to fetch report", buildingId, id, err);
        setShowModal(false);
        openedKeyRef.current = null;
      }
    })();

    return () => { cancelled = true; };
  }, [buildingId, id, directOpen]);

  useEffect(() => {
    if (!directOpen || !directReport) return;

    const reportBuildingId = directReport.buildingId;
    const reportId = directReport.id || directReport.doorId;

    if (!reportBuildingId || !reportId) {
      console.error(
        "Review directOpen: directReport is missing buildingId/id (or doorId) — cannot open modal.",
        directReport
      );
      return;
    }

    const key = `${reportBuildingId}_${reportId}`;
    if (openedKeyRef.current === key) return;

    let cancelled = false;
    (async () => {
      try {
        const full = await fetchSingleReport(reportBuildingId, reportId);
        if (cancelled) return;

        openedKeyRef.current = key;
        openReportModal(full || directReport);
      } catch (err) {
        if (cancelled) return;
        console.error("Review directOpen: failed to fetch report", reportBuildingId, reportId, err);
        openedKeyRef.current = key;
        openReportModal(directReport);
      }
    })();

    return () => { cancelled = true; };
  }, [directOpen, directReport]);

  const openReportModal = (report) => {
    setActiveTab("review");
    setSelectedReport(report);
    setSelectedPreset(0);

    const workItems = (report.workNeeded || "").split(" | ").filter(Boolean);
    const damageMultiples = {};

    const workItemToFieldMap = {
      "Replace Damaged Door": "door",
      "Repair Damaged Door": "door",
      "Replace Non-Compliant Door": "door",
      "Other (Door)": "door",
      "Repair Damaged Door Frame": "frame",
      "Replace Damaged Door Frame": "frame",
      "Other (Frame)": "frame",
      "Replace Cracked Glass": "glass",
      "Replace Non-Compliant Glass": "glass",
      "Refix Loose Glazing Beads": "glass",
      "Replace Glazing Beads": "glass",
      "Other (Glass)": "glass",
      "Clear Blocked Ventilation Gaps": "ventilation",
      "Install Additional Gaps If Needed": "ventilation",
      "Other (Ventilation)": "ventilation",
      "Repair Door Closer": "doorCloseAsIntented",
      "Adjust Door Closer": "doorCloseAsIntented",
      "Install New Door Closer": "doorCloseAsIntented",
      "Replace Door Closer": "doorCloseAsIntented",
      "Install Intumescent Strips": "doorStrips",
      "Replace Damaged Intumescent Strip": "doorStrips",
      "Replace Missing Intumescent Strip": "doorStrips",
      "Intumescent Strip Installed Incorrectly": "doorStrips",
      "Screws Missing From Hinge": "hingesWorking",
      "Install Third Fire Rated Hinge": "hingesWorking",
      "Loose Screws on Hinge": "hingesWorking",
      "Replace Broken Hinge": "hingesWorking",
      "Replace Non-Compliant Hinge": "hingesFireRating",
      "Replace Non-Compliant Locks": "lockFireRated",
      "Install Keyless Exit": "keylessExit",
      "Upgrade Non-Compliant LetterBox": "letterBoxFireRated",
      "Install Relevant Signage": "relevantSignage",
    };

    const fieldLabels = {
      door: "Door",
      frame: "Frame",
      glass: "Glass",
      ventilation: "Ventilation Gaps",
    };

    if (Array.isArray(report.damageMultiples)) {
      Object.keys(fieldLabels).forEach(key => {
        const label = fieldLabels[key];
        const found = report.damageMultiples.find(item => item.includes(label));
        damageMultiples[key] = found || `${label} Pass`;
      });
    } else if (report.damageMultiples && typeof report.damageMultiples === "object") {
      Object.keys(fieldLabels).forEach(key => {
        damageMultiples[key] = report.damageMultiples[key] || `${fieldLabels[key]} Pass`;
      });
    } else {
      Object.keys(fieldLabels).forEach(key => {
        damageMultiples[key] = `${fieldLabels[key]} Pass`;
      });
    }

    workItems.forEach((item) => {
      const fieldKey = workItemToFieldMap[item];
      if (fieldKey) {
        damageMultiples[fieldKey] = fieldLabels[fieldKey] || fieldKey;
      }
    });

    const workNeededSelections = {};
    const allSelectionFields = [
      "door", "frame", "glass", "ventilation",
      "doorCloseAsIntented", "doorStrips",
      "hingesWorking", "hingesFireRating", "lockFireRated", "keylessExit", "letterBoxFireRated", "relevantSignage"
    ];
    allSelectionFields.forEach(field => { workNeededSelections[field] = ""; });
    workItems.forEach(item => {
      const field = workItemToFieldMap[item];
      if (field && workNeededSelections[field] === "") {
        workNeededSelections[field] = item;
      }
    });

    const newFormData = {
      damageMultiples,
      workNeeded: report.workNeeded || "",
      workNeededSelections: report.workNeededSelections || workNeededSelections,
      doorCloseAsIntented: report.doorCloseAsIntented,
      doorCertif: report.doorCertif || "",
      doorStrips: report.doorStrips || false,
      hingesWorking: report.hingesWorking || false,
      hingesFireRating: report.hingesFireRating || false,
      lockFireRated: report.lockFireRated,
      keylessExit: report.keylessExit,
      letterBoxFireRated: report.letterBoxFireRated,
      relevantSignage: report.relevantSignage || true,
      fD1: report.fD1 || "",
      fD2: report.fD2 || "",
      fD3: report.fD3 || "",
      fD4: report.fD4 || "",
      damageText: report.damageText || "",
      doorDimWidth: report.doorDimWidth,
      doorDimHeight: report.doorDimHeight,
      doorDimDepth: report.doorDimDepth,
      doorLevel: report.doorLevel,
      doorLocation: report.doorLocation,
      doorUsage: report.doorUsage,
      closerType: report.closerType,
      stripType: report.stripType,
      frameMaterial: report.frameMaterial || "Wood",
      doorNumber: report.doorNumber || "",
      locksNeeded: report.locksNeeded || "",
      hasAccess: formData.hasAccess,
      noAccessReason: report.noAccessReason || "",
    };

    setFormData(newFormData);
    setDefaultValues(newFormData);
    setShowModal(true);

    setTimeout(() => {
      if (viewMode !== "finalReview") {
        hingeScrewDetection(report);
        hingeTextDetection(report);
        certTextDetection(report);
      }
    }, 600);
  };

  const handleOpenModal = (report) => {
    const key = `${report.buildingId}_${report.id}`;
    openedKeyRef.current = key;
    openReportModal(report);
    navigate(`/review/${report.buildingId}/${report.id}`);
  };

  const normalizeBool = (val) => {
    if (typeof val === "boolean" || val === null) return val;
    if (typeof val !== "string") return val;
    const lower = val.trim().toLowerCase();
    if (lower === "yes") return true;
    if (lower === "no") return false;
    if (lower === "none") return null;
    return val;
  };

  const handleOpenPresetModal = async () => {
    if (!user) return;

    try {
      const presetRef = doc(db, `users/${user.uid}/presets/1`);
      const presetSnap = await getDoc(presetRef);

      if (presetSnap.exists()) {
        setPresetData((prev) => ({
          ...prev,
          1: presetSnap.data(),
        }));
      } else {
        setPresetData((prev) => ({
          ...prev,
          1: emptyPreset,
        }));
      }

      setPresetActiveTab("1");
      setShowPresetModal(true);
    } catch (error) {
      console.error("Failed to load preset:", error);
      toast.error("Failed to load preset 1 from database.");
      setPresetData((prev) => ({
        ...prev,
        1: emptyPreset,
      }));
      setShowPresetModal(true);
    }
  };

  const handleFieldChange = (presetNumber, key, value) => {
    setPresetData((prev) => {
      const normalized = normalizeBool(value);

      const updatedPreset = {
        ...prev[presetNumber],
        [key]: normalized,
        workNeededSelections: {
          ...prev[presetNumber]?.workNeededSelections,
          [key]: normalized === true || normalized === null ? null : prev[presetNumber]?.workNeededSelections?.[key] || null,
        },
      };

      return { ...prev, [presetNumber]: updatedPreset };
    });
  };

  const applyPreset = (id) => {
    setSelectedPreset(id);

    let preset = id === 0 ? defaultValues : presetData[id] || {};

    const fieldDropdowns = {
      door: ["Replace Damaged Door", "Repair Damaged Door", "Replace Non-Compliant Door", "Other (Door)"],
      frame: ["Repair Damaged Door Frame", "Replace damaged door frame", "Other (Frame)"],
      glass: ["Replace Cracked Glass", "Replace Non-Compliant Glass", "Refix Loose Glazing Beads", "Replace Glazing Beads", "Other (Glass)"],
      ventilation: ["Clear Blocked Ventilation Gaps", "Install Additional Gaps If Needed", "Other (Ventilation)"],
      doorCloseAsIntented: ["Repair Door Closer", "Adjust Door Closer", "Install New Door Closer", "Replace Door Closer"],
      doorStrips: ["Install Intumescent Strips", "Replace Damaged Intumescent Strip", "Replace Missing Intumescent Strip", "Intumescent Strip Installed Incorrectly"],
      hingesWorking: ["Screws Missing From Hinge", "Loose Screws on Hinge", "Install Third Fire Rated Hinge", "Replace Broken Hinge"],
      hingesFireRating: ["Replace Non-Compliant Hinge"],
      lockFireRated: ["Replace Non-Compliant Locks"],
      keylessExit: ["Install Keyless Exit"],
      letterBoxFireRated: ["Upgrade Non-Compliant LetterBox"],
      relevantSignage: ["Install Relevant Signage"],
    };

    let workNeededArr = [];
    Object.keys(fieldDropdowns).forEach((key) => {
      if (!preset.workNeededSelections) preset.workNeededSelections = {};
      if (preset.workNeededSelections[key] === undefined || preset.workNeededSelections[key] === null) {
        preset.workNeededSelections[key] = "";
      }

      const selection = preset.workNeededSelections[key];
      if (selection && selection !== "") {
        workNeededArr.push(selection);
      }
    });

    setFormData((prev) => {
      const { fD1, fD2, fD3, fD4, ...restPrev } = prev;

      const updatedData = {
        ...restPrev,
        ...preset,
        doorCloseAsIntented: normalizeBool(preset.doorCloseAsIntented),
        doorStrips: normalizeBool(preset.doorStrips),
        hingesWorking: normalizeBool(preset.hingesWorking),
        hingesFireRating: normalizeBool(preset.hingesFireRating),
        lockFireRated: normalizeBool(preset.lockFireRated),
        keylessExit: normalizeBool(preset.keylessExit),
        letterBoxFireRated: normalizeBool(preset.letterBoxFireRated),
        relevantSignage: normalizeBool(preset.relevantSignage),
        workNeeded: workNeededArr.join(" | "),
      };

      updatedData.fD1 = fD1;
      updatedData.fD2 = fD2;
      updatedData.fD3 = fD3;
      updatedData.fD4 = fD4;

      return updatedData;
    });
  };

  const handlePresetWorkNeededChange = (presetNumber, key, dropdownValue) => {
    setPresetData((prev) => ({
      ...prev,
      [presetNumber]: {
        ...prev[presetNumber],
        workNeededSelections: {
          ...prev[presetNumber].workNeededSelections,
          [key]: dropdownValue,
        },
      },
    }));
  };

  const handleToggle = (key, value) => {
    setFormData((prev) => {
      let workNeededArray = prev.workNeeded ? prev.workNeeded.split(" | ") : [];

      const fieldDropdowns = {
        doorCloseAsIntented: ["Repair Door Closer", "Adjust Door Closer", "Install New Door Closer", "Replace Door Closer"],
        doorStrips: ["Install Intumescent Strips", "Replace Damaged Intumescent Strip", "Replace Missing Intumescent Strip", "Intumescent Strip Installed Incorrectly"],
        hingesWorking: ["Screws Missing From Hinge", "Loose Screws on Hinge", "Install Third Fire Rated Hinge", "Replace Broken Hinge"],
        hingesFireRating: ["Replace Non-Compliant Hinge"],
        lockFireRated: ["Replace Non-Compliant Locks"],
        keylessExit: ["Install Keyless Exit"],
        letterBoxFireRated: ["Upgrade Non-Compliant LetterBox"],
        relevantSignage: ["Install Relevant Signage"],
      };

      if (value !== false) {
        workNeededArray = workNeededArray.filter((item) => !fieldDropdowns[key].includes(item));
      }

      return {
        ...prev,
        [key]: value,
        workNeeded: workNeededArray.join(" | "),
      };
    });
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleToggle1 = (key, value) => {
    setFormData((prev) => {
      let updated = {
        ...prev,
        [key]: prev[key] === value ? "" : value,
      };

      if (key === "doorCertif" && value === "No") {
        updated.damageMultiples = {
          ...prev.damageMultiples,
          door: "Door",
        };

        let workNeededArray = prev.workNeeded
          ? prev.workNeeded.split(" | ")
          : [];

        const doorOptions = [
          "Replace Damaged Door",
          "Repair Damaged Door",
          "Replace Non-Compliant Door",
          "Other (Door)",
        ];

        workNeededArray = workNeededArray.filter(
          (item) => !doorOptions.includes(item)
        );

        workNeededArray.push("Replace Non-Compliant Door");

        updated.workNeeded = workNeededArray.join(" | ");
      }

      return updated;
    });
  };

  const handleDamageSelection = (value, key) => {
    setFormData((prev) => {
      let updatedDamageMultiples = { ...prev.damageMultiples };
      updatedDamageMultiples[key] = value;

      let updatedWorkNeeded = prev.workNeeded ? prev.workNeeded.split(" | ") : [];

      const fieldDropdowns = {
        door: ["Replace Damaged Door", "Repair Damaged Door", "Replace Non-Compliant Door", "Other (Door)"],
        frame: ["Repair Damaged Door Frame", "Replace damaged door frame", "Other (Frame)"],
        glass: ["Replace Cracked Glass", "Replace Non-Compliant Glass", "Refix Loose Glazing Beads", "Replace Glazing Beads", "Other (Glass)"],
        ventilation: ["Clear Blocked Ventilation Gaps", "Install Additional Gaps If Needed", "Other (Ventilation)"],
      };

      if (value.includes("Pass") || value.includes("None")) {
        updatedWorkNeeded = updatedWorkNeeded.filter((item) => !fieldDropdowns[key].includes(item));
      }

      return {
        ...prev,
        damageMultiples: updatedDamageMultiples,
        workNeeded: updatedWorkNeeded.join(" | "),
      };
    });
  };

  const handleWorkNeededChange = (key, value) => {
    setFormData((prev) => {
      let workNeededArray = prev.workNeeded ? prev.workNeeded.split(" | ") : [];

      const fieldDropdowns = {
        doorCloseAsIntented: ["Repair Door Closer", "Adjust Door Closer", "Install New Door Closer", "Replace Door Closer"],
        doorStrips: ["Install Intumescent Strips", "Replace Damaged Intumescent Strip", "Replace Missing Intumescent Strip", "Intumescent Strip Installed Incorrectly"],
        hingesWorking: ["Screws Missing From Hinge", "Loose Screws on Hinge", "Install Third Fire Rated Hinge", "Replace Broken Hinge"],
        hingesFireRating: ["Replace Non-Compliant Hinge"],
        lockFireRated: ["Replace Non-Compliant Locks"],
        keylessExit: ["Install Keyless Exit"],
        letterBoxFireRated: ["Upgrade Non-Compliant LetterBox"],
        relevantSignage: ["Install Relevant Signage"],
        door: ["Replace Damaged Door", "Repair Damaged Door", "Replace Non-Compliant Door", "Other (Door)"],
        frame: ["Repair Damaged Door Frame", "Replace damaged door frame", "Other (Frame)"],
        glass: ["Replace Cracked Glass", "Replace Non-Compliant Glass", "Refix Loose Glazing Beads", "Replace Glazing Beads", "Other (Glass)"],
        ventilation: ["Clear Blocked Ventilation Gaps", "Install Additional Gaps If Needed", "Other (Ventilation)"],
      };

      workNeededArray = workNeededArray.filter((item) => !fieldDropdowns[key]?.includes(item));

      if (value) {
        workNeededArray.push(value);
      }

      let gapMessages = new Set();
      if (Number(prev.fD1) > 4) gapMessages.add("Lock");
      if (Number(prev.fD2) > 4) gapMessages.add("Hinge");
      if (Number(prev.fD3) > 4) gapMessages.add("Top");
      if (Number(prev.fD4) > 8) gapMessages.add("Bottom");

      workNeededArray = workNeededArray.filter((item) => !item.startsWith("Adjust Gap"));

      if (gapMessages.size > 0) {
        workNeededArray.push(`Adjust Gap - ${Array.from(gapMessages).join(", ")}`);
      }

      return {
        ...prev,
        fD1: String(prev.fD1),
        fD2: String(prev.fD2),
        fD3: String(prev.fD3),
        fD4: String(prev.fD4),
        workNeeded: workNeededArray.join(" | "),
      };
    });
  };

  const runGapCheck = () => {
    const gapMap = {
      fD1: { label: "Lock", max: 4 },
      fD2: { label: "Hinge", max: 4 },
      fD3: { label: "Top", max: 4 },
      fD4: { label: "Bottom", max: 8 },
    };

    setFormData((prev) => {
      const updatedData = { ...prev };

      let newWorkNeeded = (prev.workNeeded || "")
        .split(" | ")
        .filter((item) => !item.startsWith("Adjust Gap"))
        .filter(Boolean);

      Object.entries(gapMap).forEach(([key, { label, max }]) => {
        const value = Number(updatedData[key]) || 0;
        if (value > max) {
          newWorkNeeded.push(`Adjust Gap - ${label}`);
        }
      });

      return {
        ...updatedData,
        workNeeded: newWorkNeeded.join(" | "),
      };
    });
  };

  const filteredReports = useMemo(() => {
    return [...reports]
      .filter(r => {
        const matchBuilding = !buildingFilter || r.buildingId === buildingFilter;
        const matchCert = !certFilter || r.doorCertif === certFilter;
        const matchDate = !dateFilter || r.date.startsWith(dateFilter);
        return matchBuilding && matchCert && matchDate;
      })
      .sort((a, b) => {
        switch (sortOption) {
          case "doorAsc":
            return (a.doorNumber || 0) - (b.doorNumber || 0);
          case "doorDesc":
            return (b.doorNumber || 0) - (a.doorNumber || 0);
          case "dateAsc":
            return new Date(a.date) - new Date(b.date);
          case "dateDesc":
            return new Date(b.date) - new Date(a.date);
          case "certAsc": {
            const certA = parseInt(a.doorCertif?.replace("FD", "") || "0", 10);
            const certB = parseInt(b.doorCertif?.replace("FD", "") || "0", 10);
            return certA - certB;
          }
          case "certDesc": {
            const certA = parseInt(a.doorCertif?.replace("FD", "") || "0", 10);
            const certB = parseInt(b.doorCertif?.replace("FD", "") || "0", 10);
            return certB - certA;
          }
          default:
            return 0;
        }
      });
  }, [reports, buildingFilter, certFilter, dateFilter, sortOption]);

  const filteredArchiveReports = useMemo(() => {
    return [...archivedReports]
      .filter(r => {
        const matchBuilding = !buildingArchiveFilter || r.buildingId === buildingArchiveFilter;
        const matchCert = !certArchiveFilter || r.doorCertif === certArchiveFilter;
        const matchDate = !dateArchiveFilter || r.date.startsWith(dateArchiveFilter);
        return matchBuilding && matchCert && matchDate;
      })
      .sort((a, b) => {
        switch (sortOption) {
          case "doorAsc":
            return (a.doorNumber || 0) - (b.doorNumber || 0);
          case "doorDesc":
            return (b.doorNumber || 0) - (a.doorNumber || 0);
          case "dateAsc":
            return new Date(a.date) - new Date(b.date);
          case "dateDesc":
            return new Date(b.date) - new Date(a.date);
          case "certAsc": {
            const certA = parseInt(a.doorCertif?.replace("FD", "") || "0", 10);
            const certB = parseInt(b.doorCertif?.replace("FD", "") || "0", 10);
            return certA - certB;
          }
          case "certDesc": {
            const certA = parseInt(a.doorCertif?.replace("FD", "") || "0", 10);
            const certB = parseInt(b.doorCertif?.replace("FD", "") || "0", 10);
            return certB - certA;
          }
          default:
            return 0;
        }
      });
  }, [archivedReports, buildingArchiveFilter, certArchiveFilter, dateArchiveFilter, sortOption]);

  const filteredFinalReviewReports = useMemo(() => {
    return [...finalReviewReports]
      .filter(r => {
        const matchBuilding = !buildingFinalReviewFilter || r.buildingId === buildingFinalReviewFilter;
        const matchCert = !certFinalReviewFilter || r.doorCertif === certFinalReviewFilter;
        const matchDate = !dateFinalReviewFilter || (r.date || "").startsWith(dateFinalReviewFilter);
        return matchBuilding && matchCert && matchDate;
      })
      .sort((a, b) => {
        switch (sortOption) {
          case "doorAsc":
            return (a.doorNumber || 0) - (b.doorNumber || 0);
          case "doorDesc":
            return (b.doorNumber || 0) - (a.doorNumber || 0);
          case "dateAsc":
            return new Date(a.date) - new Date(b.date);
          case "dateDesc":
            return new Date(b.date) - new Date(a.date);
          case "certAsc": {
            const certA = parseInt(a.doorCertif?.replace("FD", "") || "0", 10);
            const certB = parseInt(b.doorCertif?.replace("FD", "") || "0", 10);
            return certA - certB;
          }
          case "certDesc": {
            const certA = parseInt(a.doorCertif?.replace("FD", "") || "0", 10);
            const certB = parseInt(b.doorCertif?.replace("FD", "") || "0", 10);
            return certB - certA;
          }
          default:
            return 0;
        }
      });
  }, [finalReviewReports, buildingFinalReviewFilter, certFinalReviewFilter, dateFinalReviewFilter, sortOption]);

  const activeReports =
    viewMode === "review"
      ? filteredReports
      : viewMode === "finalReview"
        ? filteredFinalReviewReports
        : filteredArchiveReports;

  const activeTotalCount = activeReports.length;

  const totalPages = Math.max(
    1,
    Math.ceil(activeTotalCount / itemsPerPage)
  );

  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedReports = activeReports.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const archiveStartIndex = (currentPage - 1) * itemsPerPage;

  const paginatedArchiveReports = filteredArchiveReports.slice(
    archiveStartIndex,
    archiveStartIndex + itemsPerPage
  );

  const finalRevewStartIndex = (currentPage - 1) * itemsPerPage;

  const paginatedFinalReviewReports = filteredFinalReviewReports.slice(
    finalRevewStartIndex,
    finalRevewStartIndex + itemsPerPage
  );

  const currentPageReports =
    viewMode === "review"
      ? paginatedReports
      : viewMode === "finalReview"
        ? paginatedFinalReviewReports
        : paginatedArchiveReports;

  useEffect(() => {
    if (currentPage > totalPages) {
      setPages((previousPages) => ({
        ...previousPages,
        [viewMode]: totalPages,
      }));
    }
  }, [currentPage, totalPages, viewMode]);

  useEffect(() => {
    setLoadedPageImages(0);

    if (currentPageReports.length === 0) {
      setPageLoading(false);
    }
  }, [currentPage, viewMode, itemsPerPage]);

  useEffect(() => {
    if (
      pageLoading &&
      currentPageReports.length > 0 &&
      loadedPageImages >= currentPageReports.length
    ) {
      setPageLoading(false);
    }
  }, [
    loadedPageImages,
    currentPageReports.length,
    pageLoading,
  ]);

  const handleGapChange = (key, value) => {
    setFormData((prev) => {
      const stringValue = String(value);
      const prevValue = prev[key] ?? "";

      if (stringValue === prevValue) {
        return prev;
      }

      const updatedData = { ...prev, [key]: stringValue };

      const gapMap = {
        fD1: { label: "Lock", max: 4 },
        fD2: { label: "Hinge", max: 4 },
        fD3: { label: "Top", max: 4 },
        fD4: { label: "Bottom", max: 8 },
      };

      let newWorkNeeded = prev.workNeeded
        ? prev.workNeeded.split(" | ").filter((item) => !item.startsWith("Adjust Gap"))
        : [];

      Object.entries(gapMap).forEach(([fieldKey, { label, max }]) => {
        const numericValue = Number(updatedData[fieldKey]) || 0;
        if (numericValue > max) {
          newWorkNeeded.push(`Adjust Gap - ${label}`);
        }
      });

      return { ...updatedData, workNeeded: newWorkNeeded.join(" | ") };
    });
  };

  const compressBase64Image = (
    base64,
    {
      maxWidth = 1600,
      maxHeight = 1600,
      quality = 0.75,
      mimeType = "image/jpeg",
    } = {}
  ) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.src = `data:image/png;base64,${base64}`;

      img.onload = () => {
        let { width, height } = img;

        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        const compressedDataUrl = canvas.toDataURL(mimeType, quality);

        resolve(compressedDataUrl.split(",")[1]);
      };

      img.onerror = reject;
    });

  const [isSavingAIResult, setIsSavingAIResult] = useState(false);

  const stripDataUrlPrefix = (dataUrl) => {
    if (!dataUrl) return null;
    const match = dataUrl.match(/^data:image\/\w+;base64,(.*)$/);
    return match ? match[1] : dataUrl;
  };

  const mediaConfig = [
    { key: "closerVideoLink", label: "Closer Video" },
    { key: "doorPullPhotoLink", label: "Pull" },
    { key: "doorPushPhotoLink", label: "Push" },
    { key: "doorCertPhotoLink", label: "Certification" },
    { key: "closerPhotoLink", label: "Closer Photo" },
    { key: "hingePhotoLink", label: "Hinge 1" },
    { key: "hingePhotoLink2", label: "Hinge 2" },
    { key: "hingePhotoLink3", label: "Hinge 3" },
    { key: "glassFireStampLink", label: "Fire Stamp" },
    { key: "cupboard_contense_photo", label: "Cupboard Contents" },
    { key: "lockPhotoLink", label: "Lock Photo 1" },
    { key: "lockPhotoLink2", label: "Lock Photo 2" },
    { key: "lockPhotoLink3", label: "Lock Photo 3" },
    { key: "letterBoxPhotoLink", label: "Letter Box" },
    { key: "doorDamageLink", label: "Damage 1" },
    { key: "doorDamageLink2", label: "Damage 2" },
    { key: "doorDamageLink3", label: "Damage 3" },
    { key: "doorDamageLink4", label: "Damage 4" },
    { key: "doorDamageLink5", label: "Damage 5" },
  ];

  const mediaItems = useMemo(() => {
    return mediaConfig
      .map(({ key, label }) => ({
        key,
        label,
        src: selectedReport?.[key],
        isVideo: key === "closerVideoLink",
      }))
      .filter((item) => !!item.src);
  }, [selectedReport]);

  const [activeMedia, setActiveMedia] = useState({ open: false, index: -1 });
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragState = useRef({ startX: 0, startY: 0, origX: 0, origY: 0 });
  const mediaRef = useRef(null);

  const current = activeMedia.open ? mediaItems[activeMedia.index] : null;

  const closeModal = () => setActiveMedia({ open: false, index: -1 });

  const navigateMedia = useCallback(
    (dir) => {
      setActiveMedia((prev) => ({
        ...prev,
        index: (prev.index + dir + mediaItems.length) % mediaItems.length,
      }));
    },
    [mediaItems.length]
  );

  const resetZoom = () => {
    setZoom(1);
    setPan({ x: 0, y: 0 });
  };

  useEffect(() => {
    resetZoom();
  }, [activeMedia.index]);

  useEffect(() => {
    if (!activeMedia.open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      } else if (e.key === "ArrowLeft") {
        e.stopPropagation();
        navigateMedia(-1);
      } else if (e.key === "ArrowRight") {
        e.stopPropagation();
        navigateMedia(1);
      }
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [activeMedia.open, navigateMedia]);


  const handleWheelZoom = (e) => {
    e.preventDefault();
    setZoom((z) => {
      const next = z - e.deltaY * 0.0015;
      return Math.min(5, Math.max(0.5, next));
    });
  };

  const zoomInBtn = () => setZoom((z) => Math.min(5, z + 0.25));
  const zoomOutBtn = () =>
    setZoom((z) => {
      const next = Math.max(0.5, z - 0.25);
      if (next <= 1) setPan({ x: 0, y: 0 });
      return next;
    });

  const handleMouseDown = (e) => {
    if (zoom <= 1) return;
    setIsDragging(true);
    dragState.current = {
      startX: e.clientX,
      startY: e.clientY,
      origX: pan.x,
      origY: pan.y,
    };
  };
  const handleMouseMoveDrag = (e) => {
    if (!isDragging) return;
    const dx = e.clientX - dragState.current.startX;
    const dy = e.clientY - dragState.current.startY;
    setPan({ x: dragState.current.origX + dx, y: dragState.current.origY + dy });
  };
  const handleMouseUp = () => setIsDragging(false);
  const handleMouseLeaveMedia = () => setIsDragging(false);

  const handleTouchStart = (e) => {
    if (zoom <= 1) return;
    const point = e.touches[0];
    setIsDragging(true);
    dragState.current = {
      startX: point.clientX,
      startY: point.clientY,
      origX: pan.x,
      origY: pan.y,
    };
  };
  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const point = e.touches[0];
    const dx = point.clientX - dragState.current.startX;
    const dy = point.clientY - dragState.current.startY;
    setPan({ x: dragState.current.origX + dx, y: dragState.current.origY + dy });
  };
  const handleTouchEnd = () => setIsDragging(false);


  const CLASS_COLORS = {
    door: "#f44336",
    glass: "#00bcd4",
    safety_glass: "#0097a7",
    letter_box: "#ffeb3b",
    knocker: "#8d6e63",
    spyhole: "#9c27b0",
    door_bell: "#fbc02d",
    hinge: "#009688",
    door_closer: "#4caf50",
    fire_exit: "#2e7d32",
    keep_shut: "#ef5350",
    signage: "#ffca28",
    door_damage: "#d32f2f",
    frame_damage: "#e91e63",
    door_handle: "#fb8c00",
    night_latch: "#ff9800",
    yale_lock: "#795548",
    mortice_lock: "#3f51b5",
    keyless_exit: "#00bcd4",
    code_lock: "#2196f3",
    bolt_latch: "#ff7043",
    mortice_cover: "#7b1fa2",
    emergency_lock: "#9c27b0",
    padlock: "#607d8b",
    push_pad: "#ff5722",
    door_knob: "#fb8c00",
    ventilation: "#90a4ae",
    keep_clear: "#26c6da",
    external_lock: "#ff6f00",
    door_latch: "#558b2f",

    normal: "#4caf50",
    missing: "#f44336",
    reflection: "#ff9800",
    loose: "#66bb6a",

    fd30_sticker: "#ab47bc",
    fd30_stamp: "#8e24aa",
    fd60_sticker: "#6a1b9a",
    fd60_stamp: "#4a148c"
  };

  const handleOpenAnnotateModal = async (door, type) => {
    const configs = {
      pull: {
        photoLink: door.doorPullPhotoLink,
        annotationField: "pullAiAnnotations",
        firestoreField: "doorPullPhotoAiLink",
        fileName: "pull_photo_ai.png",
        imageName: "Pull Door Photo",
        regionClsList: [
          "bolt_latch", "code_lock", "door", "door_bell", "door_closer", "door_damage",
          "door_handle", "door_knob", "door_latch ", "door_number", "drop_down_seal",
          "emergency_lock", "external_lock", "fire_exit", "frame_damage", "glass",
          "hinge", "keep_clear", "keep_locked", "keep_shut", "keyless_exit",
          "knocker", "letter_box", "mortice_cover", "mortice_lock", "night_latch",
          "padlock", "pull_handle", "push_pad", "safety_glass", "signage", "spyhole",
          "ventilation", "yale_lock",
        ],
      },
      push: {
        photoLink: door.doorPushPhotoLink,
        annotationField: "pushAiAnnotations",
        firestoreField: "doorPushPhotoAiLink",
        fileName: "push_photo_ai.png",
        imageName: "Push Door Photo",
        regionClsList: [
          "bolt_latch", "code_lock", "door", "door_bell", "door_closer", "door_damage",
          "door_handle", "door_knob", "door_latch ", "door_number", "drop_down_seal",
          "emergency_lock", "external_lock", "fire_exit", "frame_damage", "glass",
          "hinge", "keep_clear", "keep_locked", "keep_shut", "keyless_exit",
          "knocker", "letter_box", "mortice_cover", "mortice_lock", "night_latch",
          "padlock", "pull_handle", "push_pad", "safety_glass", "signage", "spyhole",
          "ventilation", "yale_lock",
        ],
      },
      hinge1: {
        photoLink: door.hingePhotoLink,
        annotationField: "hingeAiAnnotations",
        firestoreField: "hingePhotoAiLink",
        fileName: "hinge_photo_ai.png",
        imageName: "Hinge Photo",
        regionClsList: ["loose", "missing", "normal", "reflection"],
      },
      hinge2: {
        photoLink: door.hingePhotoLink2,
        annotationField: "hinge2AiAnnotations",
        firestoreField: "hingePhotoAiLink2",
        fileName: "hinge_photo_ai2.png",
        imageName: "Hinge Photo 2",
        regionClsList: ["loose", "missing", "normal", "reflection"],
      },
      hinge3: {
        photoLink: door.hingePhotoLink3,
        annotationField: "hinge3AiAnnotations",
        firestoreField: "hingePhotoAiLink3",
        fileName: "hinge_photo_ai3.png",
        imageName: "Hinge Photo 3",
        regionClsList: ["loose", "missing", "normal", "reflection"],
      },
    };

    const config = configs[type];
    if (!config?.photoLink) {
      toast.warning(`No ${type} photo available for this door`);
      return;
    }

    try {
      const collectionType = door.type === "residential" ? "ResidentialReports" : "DoorReports";
      const annotationDocRef = doc(
        db,
        `Reports/${door.buildingId}/${collectionType}/${door.id}/ai-annotations/${config.annotationField}`
      );

      const annotationSnap = await getDoc(annotationDocRef);
      const existingRegions = annotationSnap.exists()
        ? (annotationSnap.data()?.regions || []).map((region, index) => ({
          ...region,
          id: `region_${index}`,
          color: CLASS_COLORS[region.cls] || "#ff0000",
          type: region.type || 'box',
        }))
        : [];

      setCurrentAnnotatingDoor(door);
      setShowAnnotateModalResult({
        regions: existingRegions,
        imageSrc: config.photoLink,
        imageName: config.imageName,
        regionClsList: config.regionClsList,
        fileName: config.fileName,
        firestoreField: config.firestoreField,
        annotationField: config.annotationField,
      });
      setShowManualAnnotateModal(true);
    } catch (err) {
      console.error("Error loading annotations:", err);
      toast.error("Failed to load annotations");
    }
  };


  // const handleOpenAnnotateModal = async (door, type) => {
  //   const configs = {
  //     pull: {
  //       photoLink: door.doorPullPhotoLink,
  //       annotationField: "pullAiAnnotations",
  //       firestoreField: "doorPullPhotoAiLink",
  //       fileName: "pull_photo_ai.png",
  //       imageName: "Pull Door Photo",
  //       endpoint:
  //         "http://127.0.0.1:5000/predict-door-parts",
  //       regionClsList: [
  //         "bolt_latch", "code_lock", "door", "door_bell", "door_closer", "door_damage", "door_handle", "door_knob", "door_latch ",
  //         "door_number", "drop_down_seal", "emergency_lock", "external_lock", "fire_exit", "frame_damage", "glass", "hinge",
  //         "keep_clear", "keep_locked", "keep_shut", "keyless_exit", "knocker", "letter_box", "mortice_cover", "mortice_lock",
  //         "night_latch", "padlock", "pull_handle", "push_pad", "safety_glass", "signage", "spyhole", "ventilation", "yale_lock",
  //       ],
  //     },

  //     push: {
  //       photoLink: door.doorPushPhotoLink,
  //       annotationField: "pushAiAnnotations",
  //       firestoreField: "doorPushPhotoAiLink",
  //       fileName: "push_photo_ai.png",
  //       imageName: "Push Door Photo",
  //       endpoint:
  //         "http://127.0.0.1:5000/predict-door-parts",
  //       regionClsList: [
  //         "bolt_latch", "code_lock", "door", "door_bell", "door_closer", "door_damage", "door_handle", "door_knob", "door_latch ",
  //         "door_number", "drop_down_seal", "emergency_lock", "external_lock", "fire_exit", "frame_damage", "glass", "hinge",
  //         "keep_clear", "keep_locked", "keep_shut", "keyless_exit", "knocker", "letter_box", "mortice_cover", "mortice_lock",
  //         "night_latch", "padlock", "pull_handle", "push_pad", "safety_glass", "signage", "spyhole", "ventilation", "yale_lock",
  //       ],
  //     },

  //     hinge1: {
  //       photoLink: door.hingePhotoLink,
  //       annotationField: "hingeAiAnnotations",
  //       firestoreField: "hingePhotoAiLink",
  //       fileName: "hinge_photo_ai.png",
  //       imageName: "Hinge Photo",
  //       endpoint:
  //         "https://firechecked-model-server-813451531907.europe-west1.run.app/predict-hinge-screw",
  //       regionClsList: ["loose", "missing", "normal", "reflection"],
  //     },

  //     hinge2: {
  //       photoLink: door.hingePhotoLink2,
  //       annotationField: "hinge2AiAnnotations",
  //       firestoreField: "hingePhotoAiLink2",
  //       fileName: "hinge_photo_ai2.png",
  //       imageName: "Hinge Photo 2",
  //       endpoint:
  //         "https://firechecked-model-server-813451531907.europe-west1.run.app/predict-hinge-screw",
  //       regionClsList: ["loose", "missing", "normal", "reflection"],
  //     },

  //     hinge3: {
  //       photoLink: door.hingePhotoLink3,
  //       annotationField: "hinge3AiAnnotations",
  //       firestoreField: "hingePhotoAiLink3",
  //       fileName: "hinge_photo_ai3.png",
  //       imageName: "Hinge Photo 3",
  //       endpoint:
  //         "https://firechecked-model-server-813451531907.europe-west1.run.app/predict-hinge-screw",
  //       regionClsList: ["loose", "missing", "normal", "reflection"],
  //     },
  //   };

  //   const config = configs[type];

  //   if (!config?.photoLink) {
  //     toast.warning(`No ${type} photo available for this door`);
  //     return;
  //   }

  //   try {
  //     const collectionType =
  //       door.type === "residential"
  //         ? "ResidentialReports"
  //         : "DoorReports";

  //     const annotationDocRef = doc(
  //       db,
  //       `Reports/${door.buildingId}/${collectionType}/${door.id}/ai-annotations/${config.annotationField}`
  //     );

  //     const annotationSnap = await getDoc(annotationDocRef);

  //     let regions = annotationSnap.exists()
  //       ? annotationSnap.data()?.regions || []
  //       : [];

  //     if (!regions.length) {
  //       try {
  //         toast.info("Generating AI annotations...");

  //         const imageResponse = await fetch(config.photoLink);

  //         if (!imageResponse.ok) {
  //           throw new Error(
  //             `Image fetch failed: HTTP ${imageResponse.status}`
  //           );
  //         }

  //         const blob = await imageResponse.blob();

  //         const base64Image = await new Promise((resolve, reject) => {
  //           const reader = new FileReader();

  //           reader.onloadend = () => {
  //             const result = reader.result;

  //             const base64 = String(result).split(",")[1];

  //             resolve(base64);
  //           };

  //           reader.onerror = reject;
  //           reader.readAsDataURL(blob);
  //         });

  //         const response = await fetch(config.endpoint, {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             image: base64Image,
  //           }),
  //         });

  //         if (!response.ok) {
  //           throw new Error(
  //             `AI request failed: HTTP ${response.status}`
  //           );
  //         }

  //         const data = await response.json();

  //         console.log(`${type} AI response:`, data);

  //         if (Array.isArray(data?.regions)) {
  //           regions = data.regions;


  //           const mappedRegions = regions.map((region) => {
  //             const base = {
  //               cls: region.cls || "",
  //               type: region.type || "box",
  //             };

  //             if (region.type === "polygon") {
  //               return {
  //                 ...base,
  //                 type: "polygon",
  //                 pointsX: (region.points || []).map((p) => p[0]),
  //                 pointsY: (region.points || []).map((p) => p[1]),
  //               };
  //             }

  //             return {
  //               ...base,
  //               x: region.x || 0,
  //               y: region.y || 0,
  //               w: region.w || 0,
  //               h: region.h || 0,
  //             };
  //           });

  //           await setDoc(
  //             annotationDocRef,
  //             {
  //               regions: mappedRegions,
  //               updatedAt: serverTimestamp(),
  //               createdAt:
  //                 annotationSnap.exists() &&
  //                   annotationSnap.data()?.createdAt
  //                   ? annotationSnap.data().createdAt
  //                   : serverTimestamp(),
  //             },
  //             {
  //               merge: true,
  //             }
  //           );

  //           regions = mappedRegions;

  //           toast.success("AI annotations generated");
  //         } else {
  //           regions = [];
  //           toast.info("No AI annotations detected");
  //         }
  //       } catch (aiError) {
  //         console.error(
  //           `AI annotation error (${type}):`,
  //           aiError
  //         );

  //         toast.error("Failed to generate AI annotations");

  //         regions = [];
  //       }
  //     }

  //     const existingRegions = regions.map((region, index) => {
  //       if (region.type === "polygon") {
  //         return {
  //           ...region,
  //           id: `region_${index}`,
  //           color: CLASS_COLORS[region.cls] || "#ff0000",
  //           type: "polygon",

  //           points:
  //             region.points ||
  //             (region.pointsX || []).map((x, i) => [
  //               x,
  //               region.pointsY?.[i],
  //             ]),
  //         };
  //       }

  //       return {
  //         ...region,
  //         id: `region_${index}`,
  //         color: CLASS_COLORS[region.cls] || "#ff0000",
  //         type: region.type || "box",
  //       };
  //     });

  //     setCurrentAnnotatingDoor(door);

  //     setShowAnnotateModalResult({
  //       regions: existingRegions,
  //       imageSrc: config.photoLink,
  //       imageName: config.imageName,
  //       regionClsList: config.regionClsList,
  //       fileName: config.fileName,
  //       firestoreField: config.firestoreField,
  //       annotationField: config.annotationField,
  //     });

  //     setShowManualAnnotateModal(true);
  //   } catch (err) {
  //     console.error("Error loading annotations:", err);
  //     toast.error("Failed to load annotations");
  //   }
  // };

  const saveAIImage = async ({
    base64Image,
    fileName,
    firestoreField,
    annotationField,
    regions = [],
    onSuccess,
  }) => {
    if (!base64Image || !selectedReport || isSavingAIResult) return;

    try {
      setIsSavingAIResult(true);

      setDisplayedText('');
      setMessageIndex(0);
      setCharIndex(0);
      setMessages([
        "saving annotations...",
      ]);
      setLoading(true);

      const collectionType =
        selectedReport.type === "residential"
          ? "ResidentialReports"
          : "DoorReports";

      const mappedRegions = regions.map(region => {
        const commonData = {
          cls: region.cls || '',
          type: region.type || 'box',
        };

        if (region.type === 'polygon') {
          const pointsX = [];
          const pointsY = [];
          (region.points || []).forEach(p => {
            pointsX.push(p[0]);
            pointsY.push(p[1]);
          });
          return {
            ...commonData,
            type: 'polygon',
            pointsX,
            pointsY,
          };
        } else {
          return {
            ...commonData,
            x: region.x || 0,
            y: region.y || 0,
            w: region.w || 0,
            h: region.h || 0,
          };
        }
      });

      const annotationDocRef = doc(
        db,
        `Reports/${selectedReport.buildingId}/${collectionType}/${selectedReport.id}/ai-annotations/${annotationField}`
      );

      const existingDoc = await getDoc(annotationDocRef);
      const createdAt = existingDoc.exists() && existingDoc.data()?.createdAt
        ? existingDoc.data()?.createdAt
        : serverTimestamp();

      await setDoc(
        annotationDocRef,
        {
          regions: mappedRegions,
          updatedAt: serverTimestamp(),
          createdAt,
        },
        { merge: true }
      );

      onSuccess?.();
    } catch (error) {
      console.error("Failed to save AI image + annotations:", error);
    } finally {
      setIsSavingAIResult(false);
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedReport) return;

    scrollPositionRef.current =
      window.pageYOffset || document.documentElement.scrollTop;

    setLoading(true);

    try {
      const collectionType =
        selectedReport.type === "residential"
          ? "ResidentialReports"
          : "DoorReports";

      const docRef = doc(
        db,
        `Reports/${selectedReport.buildingId}/${collectionType}/${selectedReport.id}`
      );

      const { workNeededSelections, ...dataWithoutSelections } = formData;

      const updatedData = {
        ...dataWithoutSelections,

        damageMultiples: Array.isArray(formData.damageMultiples)
          ? formData.damageMultiples
          : Object.values(formData.damageMultiples || {}),

        workNeeded: formData.workNeeded ?? null,
      };

      const cleanedData = Object.fromEntries(
        Object.entries(updatedData).filter(
          ([_, value]) => value !== undefined
        )
      );

      await updateDoc(docRef, cleanedData);

      setSubmitted(true);

      setReports((prevReports) =>
        prevReports.map((report) =>
          report.id === selectedReport.id
            ? { ...report, ...cleanedData }
            : report
        )
      );

      setFinalReviewReports((prevReports) =>
        prevReports.map((report) =>
          report.id === selectedReport.id
            ? { ...report, ...cleanedData }
            : report
        )
      );
    } catch (error) {
      console.error("Error updating report:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveFinalSubmit = async () => {
    const { buildingId, id, type } = selectedReport || {};
    if (!buildingId) return;

    const collectionType = selectedReport?.type === "residential" ? "ResidentialReports" : "DoorReports";

    try {
      scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
      setLoading(true);

      const docRef1 = doc(db, `Reports/${buildingId}/${collectionType}/${id}`);
      // await updateDoc(docRef1, { requiresFinalReview: true });
      await updateDoc(docRef1, { requiresReview: false });

      setReports((prev) => prev.filter((r) => r.id !== id));

      setFinalReviewReports((prev) => {
        const alreadyThere = prev.some((r) => r.id === id);
        if (alreadyThere) return prev;
        return [
          // { ...selectedReport, ...formData, requiresReview: true, requiresFinalReview: true },
          { ...selectedReport, ...formData, requiresReview: false, },
          ...prev,
        ];
      });
    } catch (error) {
      console.error("Error saving final submit:", error);
    } finally {
      setLoading(false);
      setShowModal(false);
      openedKeyRef.current = null;
      goBack();
      setTimeout(() => setSaveStatus(null), 3000);
    }
  };

  const hingeScrewDetection = (report) => {
    const links = [
      report?.hingePhotoLink,
      report?.hingePhotoLink2,
      report?.hingePhotoLink3,
    ].filter((l) => l && l !== "null" && l !== "undefined" && l.trim() !== "");

    try {
      const rawCounts = [
        report?.hingePhotoCount,
        report?.hingePhotoCount2,
        report?.hingePhotoCount3,
      ].filter(Boolean);

      const mergedCounts = rawCounts.reduce(
        (acc, c) => ({
          normal: acc.normal + (c?.normal ?? 0),
          missing: acc.missing + (c?.missing ?? 0),
          loose: acc.loose + (c?.loose ?? 0),
          reflection: acc.reflection + (c?.reflection ?? 0),
        }),
        { normal: 0, missing: 0, loose: 0, reflection: 0 }
      );

      applyHingeResult(mergedCounts, links.length);
    } catch (err) {
      console.error("Error detecting hinge screws:", err);
      alert("Failed to detect hinge screws");
    }
  };

  const applyHingeResult = (counts, photoCount) => {
    const normal = counts?.normal ?? 0;
    const missing = counts?.missing ?? 0;
    const loose = counts?.loose ?? 0;
    const reflection = counts?.reflection ?? 0;

    const noDetection = normal === 0 && missing === 0 && loose === 0 && reflection === 0;

    const expectedScrews = photoCount * 8;

    let toggleValue = true;
    let workNeededValues = [];

    if (photoCount < 3) {
      toggleValue = false;
      workNeededValues.push("Install Third Fire Rated Hinge");
    }

    if (!noDetection) {
      if (missing > 0 || normal < expectedScrews) {
        toggleValue = false;
        workNeededValues.push("Screws Missing From Hinge");
      } else if (loose > 0) {
        toggleValue = false;
        workNeededValues.push("Loose Screws on Hinge");
      }
    } else {
      toggleValue = false;
    }

    setFormData((prev) => {
      let workNeededArray = prev.workNeeded ? prev.workNeeded.split(" | ") : [];

      const hingesDropdown = [
        "Screws Missing From Hinge",
        "Loose Screws on Hinge",
        "Install Third Fire Rated Hinge",
        "Replace Broken Hinge",
      ];

      workNeededArray = workNeededArray.filter((item) => !hingesDropdown.includes(item));
      workNeededValues.forEach((v) => workNeededArray.push(v));

      return {
        ...prev,
        hingesWorking: toggleValue,
        workNeeded: workNeededArray.join(" | "),
      };
    });
  };

  const hingeTextDetection = (report) => {
    const hingePhotoTextFinal = report.hingePhotoTextM ?? report.hingePhotoText;
    const hingePhotoTextFinal2 = report.hingePhotoTextM2 ?? report.hingePhotoText2;
    const hingePhotoTextFinal3 = report.hingePhotoTextM3 ?? report.hingePhotoText3;

    const result1 = applyHingeTextResult(hingePhotoTextFinal);
    const result2 = applyHingeTextResult(hingePhotoTextFinal2);
    const result3 = applyHingeTextResult(hingePhotoTextFinal3);

    const certifiedCount = [result1.certified, result2.certified, result3.certified].filter(Boolean).length;
    const overallCertified = certifiedCount >= 1;

    setFormData((prev) => {
      let workNeededArray = prev.workNeeded ? prev.workNeeded.split(" | ") : [];
      const hingeTextDropdown = ["Replace Non-Compliant Hinge"];
      workNeededArray = workNeededArray.filter((item) => !hingeTextDropdown.includes(item));

      if (!overallCertified) {
        workNeededArray.push("Replace Non-Compliant Hinge");
      }

      return {
        ...prev,
        hingesFireRating: overallCertified,
        workNeeded: workNeededArray.join(" | "),
      };
    });

    return {
      hingeText1Certified: result1.certified,
      hingeText1Confidence: result1.confidence,
      hingeText1Matches: result1.matches,

      hingeText2Certified: result2.certified,
      hingeText2Confidence: result2.confidence,
      hingeText2Matches: result2.matches,

      hingeText3Certified: result3.certified,
      hingeText3Confidence: result3.confidence,
      hingeText3Matches: result3.matches,

      hingeTextCertified: overallCertified,
    };
  };

  const applyHingeTextResult = (text) => {
    if (!text) return { certified: false, confidence: 0, matches: [] };

    const upper = text.toUpperCase();
    const matches = [];

    const checks = [
      { pattern: /\b[CG][E3]\b/, label: "CE" },
      { pattern: /EURO/, label: "Euro" },
      { pattern: /CERTIF[Il1]ED/, label: "Certified" },
      { pattern: /BRIT[Il1]SH/, label: "British" },
      { pattern: /CERT[Il1]F[Il1]RE|CERTIF[Il1]ER/, label: "Certifier" },
      { pattern: /GRADE\s*1[3]/, label: "Grade 13" },
      { pattern: /GRADE\s*1[1]/, label: "Grade 11" },
      { pattern: /JEDO/, label: "JEDO" },
      { pattern: /UK/, label: "UK" },
    ];

    for (const { pattern, label } of checks) {
      if (pattern.test(upper)) matches.push(label);
    }

    const certified = matches.length > 0;
    const confidence = Math.round((matches.length / checks.length) * 100);

    return { certified, confidence, matches };
  };

  const certTextDetection = (report) => {
    const certPhotoText = report.doorCertifText;
    const doorDepth = report.doorDimDepth;

    const result = applyCertTextResult(certPhotoText);

    const hasPhoto = Boolean(report.doorCertPhotoLink);
    const isThickDoor = doorDepth != null && Number(doorDepth) >= 44;
    const noTextMatch = !result.matches || result.matches.length === 0;

    let finalRating = result.rating;

    if (hasPhoto && isThickDoor && noTextMatch) {
      finalRating = "Assumed";
    }

    setFormData((prev) => {
      let workNeededArray = prev.workNeeded ? prev.workNeeded.split(" | ") : [];

      const hingeWorkItem = "Replace Non-Compliant Hinge";
      const doorOptions = [
        "Replace Damaged Door",
        "Repair Damaged Door",
        "Replace Non-Compliant Door",
        "Other (Door)",
      ];

      workNeededArray = workNeededArray.filter((item) => item !== hingeWorkItem);

      if (finalRating === "No") {
        workNeededArray = workNeededArray.filter(
          (item) => !doorOptions.includes(item)
        );

        workNeededArray.push("Replace Non-Compliant Door");

        return {
          ...prev,
          doorCertif: "No",
          damageMultiples: {
            ...prev.damageMultiples,
            door: "Door",
          },
          workNeeded: workNeededArray.join(" | "),
        };
      }

      if (finalRating === "Assumed") {
        workNeededArray = workNeededArray.filter(
          (item) => !doorOptions.includes(item)
        );

        return {
          ...prev,
          doorCertif: "Assumed",
          workNeeded: workNeededArray.join(" | "),
        };
      }

      return {
        ...prev,
        doorCertif: finalRating,
        workNeeded: workNeededArray.join(" | "),
      };
    });

    return {
      doorCertifRating: finalRating,
      doorCertifConfidence: result.confidence,
      doorCertifMatches: result.matches,
    };
  };

  const applyCertTextResult = (text) => {
    if (!text) return { rating: "No", confidence: 0, matches: [] };

    const upper = text.toUpperCase();
    const matches = [];

    const checks = [
      { pattern: /\bFD\s*-?\s*60\b/, label: "FD60", rating: "FD60", explicit: true },
      { pattern: /\b60\s*MIN(UTE)?S?\b/, label: "60 min", rating: "FD60", explicit: true },
      { pattern: /\bDOOR\s*-?\s*60\b/, label: "Door 60", rating: "FD60", explicit: true },

      { pattern: /\bFD\s*-?\s*30\b/, label: "FD30", rating: "FD30", explicit: true },
      { pattern: /\b30\s*MIN(UTE)?S?\b/, label: "30 min", rating: "FD30", explicit: true },
      { pattern: /\bDOOR\s*-?\s*30\b/, label: "Door 30", rating: "FD30", explicit: true },

      { pattern: /\bFIRE\s*DOOR\b/, label: "Fire Door", rating: "FD30", explicit: false },
      { pattern: /\bFD\b/, label: "FD", rating: "FD30", explicit: false },
      { pattern: /\bJELD\s*-?\s*WEN\b/, label: "Jeld-Wen", rating: "FD30", explicit: false },
      { pattern: /\bCERTIF[I1L]CATE\b/, label: "Certificate", rating: "FD30", explicit: false },
      { pattern: /\bCERTIF[I1L]ED\b/, label: "Certified", rating: "FD30", explicit: false },
      { pattern: /\bCERTIF[I1L]RE\b/, label: "Certifire", rating: "FD30", explicit: false },
      { pattern: /\bBS\s*476\b/, label: "BS476", rating: "FD30", explicit: false },
      { pattern: /\bBM\s*TRADA\b/, label: "BM TRADA", rating: "FD30", explicit: false },
      { pattern: /\bCE\b/, label: "CE", rating: "FD30", explicit: false },
      { pattern: /\bBRIT[I1L]SH\s*STANDARD\b/, label: "British Standard", rating: "FD30", explicit: false },
      { pattern: /\bUK\s*CERT\b/, label: "UK Cert", rating: "FD30", explicit: false },
    ];

    let detectedRating = null;
    let detectedExplicit = false;

    for (const { pattern, label, rating, explicit } of checks) {
      if (pattern.test(upper)) {
        matches.push(label);

        if (explicit) {
          if (!detectedExplicit || rating === "FD60") {
            detectedRating = rating;
            detectedExplicit = true;
          }
        } else if (!detectedExplicit && !detectedRating) {
          detectedRating = rating;
        }
      }
    }

    const rating = detectedRating || "No";
    const confidence = detectedRating
      ? Math.round((matches.length / checks.length) * 100)
      : 0;

    return { rating, confidence, matches };
  };

  const [messages, setMessages] = useState([
    "Fetching unreviewed doors...",
    "Compiling results...",
    "Almost there..."
  ]);

  const [messageIndex, setMessageIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    const currentMessage = messages[messageIndex];

    if (charIndex < currentMessage.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(currentMessage.slice(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, 30);
      return () => clearTimeout(timeout);
    } else {
      const delay = setTimeout(() => {
        setMessageIndex((prev) => (prev + 1) % messages.length);
        setCharIndex(0);
        setDisplayedText('');
      }, 1500);
      return () => clearTimeout(delay);
    }
  }, [charIndex, messageIndex]);

  if (directOpen && !directReport) return null;

  if (directOpen && !showModal) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1055,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0, 0, 0, 0.35)",
        }}
      >
        <ClipLoader color="#b11111" size={50} />
      </div>
    );
  }

  if (loading && !directOpen && !isDeepLink) return (
    <div className="loading-container">
      <ClipLoader color="#b11111" size={60} />
      <div className="loading-text">
        {displayedText}
        <span className="cursor">|</span>
      </div>
    </div>
  );

  const savePrices = async () => {
    const { buildingId, doorId, id, type } = selectedReport || {};
    if (!buildingId || !doorId) return;

    const allEmpty = Object.values(prices).every(
      (value) => value === 0 || value === "" || value === null
    );

    const noChanges =
      JSON.stringify(prices) === JSON.stringify(originalPrices) &&
      laborCost === originalLaborCost &&
      includeVAT === originalIncludeVAT &&
      includeManagementFee === originalIncludeManagementFee;

    const collectionType = selectedReport?.type === "residential" ? "ResidentialReports" : "DoorReports";

    const priceData = {
      ...prices,
      laborCost: laborCost || 0,
      includeVAT,
      includeManagementFee,
    };

    try {
      scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;
      setLoading(true);

      const docRef = doc(
        db,
        `Reports/${buildingId}/${collectionType}/${doorId}/prices/${doorId}`
      );
      await setDoc(docRef, priceData);

      const docRef1 = doc(db, `Reports/${buildingId}/${collectionType}/${id}`);
      await updateDoc(docRef1, { requiresReview: false });

      setSaveStatus({ type: "success", message: "Prices saved successfully!" });
      setOriginalPrices(prices);
      setReports((prev) => prev.filter((r) => r.id !== id));
    } catch (error) {
      console.error("Error saving prices:", error);
      setSaveStatus({ type: "danger", message: "Failed to save prices." });
    } finally {
      setLoading(false);
      setShowModal(false);
      openedKeyRef.current = null;
      goBack();
      setTimeout(() => setSaveStatus(null), 3000);
    }
  };

  const fetchPrices = async () => {
    if (!selectedReport?.buildingId || !selectedReport?.doorId) return;

    const collectionType = selectedReport?.type === "residential" ? "ResidentialReports" : "DoorReports";

    const docRef = doc(
      db,
      `Reports/${selectedReport.buildingId}/${collectionType}/${selectedReport.doorId}/prices/${selectedReport.doorId}`
    );

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const fetchedData = docSnap.data();

        const { laborCost = "", includeVAT = false, includeManagementFee = false, ...restPrices } = fetchedData;

        setPrices(restPrices);
        setOriginalPrices(restPrices);

        setLaborCost(laborCost);
        setOriginalLaborCost(laborCost);

        setIncludeVAT(includeVAT);
        setOriginalIncludeVAT(includeVAT);

        setIncludeManagementFee(includeManagementFee);
        setOriginalIncludeManagementFee(includeManagementFee);
      } else {
        setPrices({});
        setOriginalPrices({});
        setLaborCost("");
        setOriginalLaborCost("");
        setIncludeVAT(false);
        setOriginalIncludeVAT(false);
        setIncludeManagementFee(false);
        setOriginalIncludeManagementFee(false);
      }
    } catch (error) {
      console.error("Error fetching prices:", error);
      setPrices({});
      setOriginalPrices({});
      setLaborCost("");
      setOriginalLaborCost("");
      setIncludeVAT(false);
      setOriginalIncludeVAT(false);
      setIncludeManagementFee(false);
      setOriginalIncludeManagementFee(false);
    }
  };

  const PaginationControls = ({
    currentPage,
    totalPages,
    onPageChange,
    itemsPerPage,
    onItemsPerPageChange,
    totalCount,
    pageLoading,
  }) => {
    if (totalCount === 0) return null;

    const start = (currentPage - 1) * itemsPerPage + 1;
    const end = Math.min(currentPage * itemsPerPage, totalCount);

    const getPageNumbers = () => {
      const pages = [];
      const maxVisible = 5;

      let startPage = Math.max(
        1,
        currentPage - Math.floor(maxVisible / 2)
      );

      let endPage = startPage + maxVisible - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxVisible + 1);
      }

      for (let page = startPage; page <= endPage; page++) {
        pages.push(page);
      }

      return pages;
    };

    const pageNumbers = getPageNumbers();

    const changePage = (page) => {
      const validPage = Math.max(1, Math.min(page, totalPages));

      if (validPage !== currentPage) {
        onPageChange(validPage);
      }
    };

    return (
      <div
        className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 mt-4 mb-2 px-2"
        style={{
          position: "relative",
          zIndex: 10,
          overflow: "visible",
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <small className="text-muted">
          Showing {start} – {end} of {totalCount}
        </small>

        <div className="d-flex align-items-center gap-2">
          <div className="btn-group btn-group-sm" role="group">

            <Button
              type="button"
              variant="outline-secondary"
              size="sm"
              disabled={pageLoading || currentPage === 1}
              onClick={(event) => {
                event.stopPropagation();
                onPageChange(currentPage - 1);
              }}
            >
              <i className="bi bi-chevron-left" />
            </Button>

            {pageNumbers.length > 0 && pageNumbers[0] > 1 && (
              <>
                <Button
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  disabled={pageLoading}
                  onClick={(event) => {
                    event.stopPropagation();
                    onPageChange(1);
                  }}
                >
                  1
                </Button>

                {pageNumbers[0] > 2 && (
                  <span className="text-muted px-1 d-flex align-items-center">
                    …
                  </span>
                )}
              </>
            )}

            {pageNumbers.map((page) => (
              <Button
                type="button"
                key={page}
                variant={
                  page === currentPage
                    ? "danger"
                    : "outline-secondary"
                }
                size="sm"
                disabled={pageLoading}
                onClick={(event) => {
                  event.stopPropagation();
                  onPageChange(page);
                }}
              >
                {page}
              </Button>
            ))}

            {pageNumbers.length > 0 &&
              pageNumbers[pageNumbers.length - 1] < totalPages && (
                <>
                  {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
                    <span className="text-muted px-1 d-flex align-items-center">
                      …
                    </span>
                  )}

                  <Button
                    type="button"
                    variant="outline-secondary"
                    size="sm"
                    disabled={pageLoading}
                    onClick={(event) => {
                      event.stopPropagation();
                      onPageChange(totalPages);
                    }}
                  >
                    {totalPages}
                  </Button>
                </>
              )}

            <Button
              type="button"
              variant="outline-secondary"
              size="sm"
              disabled={pageLoading || currentPage === totalPages}
              onClick={(event) => {
                event.stopPropagation();
                onPageChange(currentPage + 1);
              }}
            >
              <i className="bi bi-chevron-right" />
            </Button>
          </div>

          <select
            className="form-select form-select-sm pagination-select"
            value={itemsPerPage}
            disabled={pageLoading}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) =>
              onItemsPerPageChange(Number(event.target.value))
            }
            style={{
              width: "110px",
              minWidth: "110px",
              cursor: pageLoading ? "not-allowed" : "pointer",
              position: "relative",
              zIndex: 11,
            }}
          >
            <option value={24}>24 / page</option>
            <option value={48}>48 / page</option>
            <option value={96}>96 / page</option>
          </select>
        </div>
      </div>
    );
  };

  const doorLabel = (report) =>
    (report.type === "residential" ? "R" : "C") +
    (report.doorNumber
      ? report.doorNumber
      : report.originalIndex != null
        ? report.originalIndex + 1
        : "N/A");

  const goBack = () => {
    if (directOpen) {
      onDirectClose?.();
    } else {
      navigate("/review");
    }
  };

  return (
    <div className="review-container">

      <ToastContainer autoClose={1000} />

      <AnnotateModal
        show={showManualAnnotateModal}
        imageSrc={showAnnotateModalResult?.imageSrc}
        regionClsList={showAnnotateModalResult?.regionClsList || []}
        regions={showAnnotateModalResult?.regions || []}
        imageName={showAnnotateModalResult?.imageName}
        onClose={() => {
          setShowManualAnnotateModal(false);
          setCurrentAnnotatingDoor(null);
          setShowAnnotateModalResult(null);
        }}
        onSave={({ regions, base64 }) => {
          if (!showAnnotateModalResult || !currentAnnotatingDoor) return;

          saveAIImage({
            base64Image: base64,
            fileName: showAnnotateModalResult.fileName,
            firestoreField: showAnnotateModalResult.firestoreField,
            annotationField: showAnnotateModalResult.annotationField,
            regions,
            onSuccess: () => {
              toast.success("Annotation saved successfully!", {
                icon: <FontAwesomeIcon icon={faCircleCheck} size="lg" style={{ color: "green" }} />,
                autoClose: 2000,
                style: {
                  backgroundColor: "#e6ffed",
                  color: "#064e3b",
                  borderLeft: "4px solid green",
                  fontSize: "14px",
                },
              });
              setShowManualAnnotateModal(false);
              setCurrentAnnotatingDoor(null);
              setShowAnnotateModalResult(null);
            },
          });
        }}
      />

      {!directOpen && (
        <>
          <div className="mb-4">
            <div
              className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3 p-3 bg-white rounded-3 shadow-sm"
              style={{ border: "1px solid #dee2e6" }}
            >

              <div className="d-flex align-items-center gap-3">
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <h2 className="mb-0 fs-4 fw-bold text-dark">
                      {viewMode === "review" ? "Review" : viewMode === "finalReview" ? "Final Review" : "Archive"}
                    </h2>
                    <div className="btn-group btn-group-sm" role="group">
                      <button
                        type="button"
                        className={`btn ${viewMode === "review" ? "btn-danger" : "btn-outline-secondary"}`}
                        style={{ borderRadius: "20px 0 0 20px", fontSize: "0.75rem", padding: "2px 10px" }}
                        onClick={() => setViewMode("review")}
                      >
                        <i className="bi bi-clipboard-check me-1"></i>Review
                        <span className={`badge ms-1 ${viewMode === "review" ? "bg-white text-danger" : "bg-secondary"}`} style={{ fontSize: "0.6rem" }}>
                          {reports.length}
                        </span>
                      </button>
                      {/* {role === "admin" && (
                            <button
                              type="button"
                              className={`btn ${viewMode === "finalReview" ? "btn-danger" : "btn-outline-secondary"}`}
                              style={{ fontSize: "0.75rem", padding: "2px 10px" }}
                              onClick={() => setViewMode("finalReview")}
                            >
                              <i className="bi bi-check2-square me-1"></i>Final Review
                              <span className={`badge ms-1 ${viewMode === "finalReview" ? "bg-white text-danger" : "bg-secondary"}`} style={{ fontSize: "0.6rem" }}>
                                {finalReviewReports.length}
                              </span>
                            </button>
                          )} */}
                      <button
                        type="button"
                        className={`btn ${viewMode === "archive" ? "btn-danger" : "btn-outline-secondary"}`}
                        style={{ borderRadius: "0 20px 20px 0", fontSize: "0.75rem", padding: "2px 10px" }}
                        onClick={() => setViewMode("archive")}
                      >
                        <i className="bi bi-archive me-1"></i>Archive
                        <span className={`badge ms-1 ${viewMode === "archive" ? "bg-white text-danger" : "bg-secondary"}`} style={{ fontSize: "0.6rem" }}>
                          {archivedReports.length}
                        </span>
                      </button>
                    </div>
                  </div>

                  <small className="text-muted">
                    <i className="bi bi-file-text me-1"></i>
                    {viewMode === "review"
                      ? `${filteredReports.length} ${filteredReports.length === 1 ? "report" : "reports"}`
                      : viewMode === "finalReview"
                        ? `${filteredFinalReviewReports.length} ${filteredFinalReviewReports.length === 1 ? "report" : "reports"}`
                        : `${filteredArchiveReports.length} ${filteredArchiveReports.length === 1 ? "report" : "reports"}`}
                  </small>
                </div>
              </div>

              {viewMode === "review" && (
                <div className="d-flex flex-wrap align-items-center gap-2 filter-row">

                  <div
                    className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                    style={{
                      backgroundColor: sortOption !== sortOptions[0]?.value ? "#fff5f5" : "#f8f9fa",
                      border: sortOption !== sortOptions[0]?.value ? "1px solid #dc3545" : "1px solid transparent",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <i className="bi bi-sort-down text-muted"></i>
                    <Form.Select
                      value={sortOption}
                      onChange={e => setSortOption(e.target.value)}
                      size="sm"
                      className="border-0 bg-transparent fw-medium"
                      style={{
                        width: "140px",
                        cursor: "pointer",
                        boxShadow: "none",
                        outline: "none"
                      }}
                    >
                      {sortOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </Form.Select>
                  </div>

                  {uniqueBuildings.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: buildingFilter ? "#fff5f5" : "#f8f9fa",
                        border: buildingFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-building ${buildingFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={buildingFilter}
                        onChange={e => setBuildingFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "160px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: buildingFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Buildings</option>
                        {uniqueBuildings.map(b => (
                          <option key={b.id} value={b.id}>{b.name}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {uniqueCerts.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: certFilter ? "#fff5f5" : "#f8f9fa",
                        border: certFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-award ${certFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={certFilter}
                        onChange={e => setCertFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "160px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: certFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Certificates</option>
                        {uniqueCerts.map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {uniqueDates.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: dateFilter ? "#fff5f5" : "#f8f9fa",
                        border: dateFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-calendar3 ${dateFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={dateFilter}
                        onChange={e => setDateFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "140px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: dateFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Dates</option>
                        {uniqueDates.map(d => (
                          <option key={d.value} value={d.value}>{d.label}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {/* <div className="vr d-none d-lg-block" style={{ height: "50px" }}></div>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={handleOpenPresetModal}
                        className="rounded-pill px-3 py-2 fw-medium shadow-sm"
                      >
                        <i className="bi bi-gear-fill me-2"></i>
                        Presets
                      </Button> */}
                </div>
              )}

              {viewMode === "finalReview" && (
                <div className="d-flex flex-wrap align-items-center gap-2 filter-row">

                  <div
                    className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                    style={{
                      backgroundColor: sortOption !== sortOptions[0]?.value ? "#fff5f5" : "#f8f9fa",
                      border: sortOption !== sortOptions[0]?.value ? "1px solid #dc3545" : "1px solid transparent",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <i className="bi bi-sort-down text-muted"></i>
                    <Form.Select
                      value={sortOption}
                      onChange={e => setSortOption(e.target.value)}
                      size="sm"
                      className="border-0 bg-transparent fw-medium"
                      style={{
                        width: "140px",
                        cursor: "pointer",
                        boxShadow: "none",
                        outline: "none"
                      }}
                    >
                      {sortOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </Form.Select>
                  </div>

                  {uniqueFinalReviewBuildings.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: buildingFinalReviewFilter ? "#fff5f5" : "#f8f9fa",
                        border: buildingFinalReviewFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-building ${buildingFinalReviewFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={buildingFinalReviewFilter}
                        onChange={e => setBuildingFinalReviewFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "160px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: buildingFinalReviewFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Buildings</option>
                        {uniqueFinalReviewBuildings.map(b => (
                          <option key={b.id} value={b.id}>{b.name}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {uniqueFinalReviewCerts.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: certFinalReviewFilter ? "#fff5f5" : "#f8f9fa",
                        border: certFinalReviewFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-award ${certFinalReviewFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={certFinalReviewFilter}
                        onChange={e => setFinalReviewCertFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "160px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: certFinalReviewFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Certificates</option>
                        {uniqueFinalReviewCerts.map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {uniqueFinalReviewDates.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: dateFinalReviewFilter ? "#fff5f5" : "#f8f9fa",
                        border: dateFinalReviewFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-calendar3 ${dateFinalReviewFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={dateFinalReviewFilter}
                        onChange={e => setFinalReviewDateFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "140px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: dateFinalReviewFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Dates</option>
                        {uniqueFinalReviewDates.map(d => (
                          <option key={d.value} value={d.value}>{d.label}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}
                </div>
              )}

              {viewMode === "archive" && (
                <div className="d-flex flex-wrap align-items-center gap-2 filter-row">

                  <div
                    className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                    style={{
                      backgroundColor: sortOption !== sortOptions[0]?.value ? "#fff5f5" : "#f8f9fa",
                      border: sortOption !== sortOptions[0]?.value ? "1px solid #dc3545" : "1px solid transparent",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <i className="bi bi-sort-down text-muted"></i>
                    <Form.Select
                      value={sortOption}
                      onChange={e => setSortOption(e.target.value)}
                      size="sm"
                      className="border-0 bg-transparent fw-medium"
                      style={{
                        width: "140px",
                        cursor: "pointer",
                        boxShadow: "none",
                        outline: "none"
                      }}
                    >
                      {sortOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </Form.Select>
                  </div>

                  {uniqueArchiveBuildings.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: buildingArchiveFilter ? "#fff5f5" : "#f8f9fa",
                        border: buildingArchiveFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-building ${buildingArchiveFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={buildingArchiveFilter}
                        onChange={e => setBuildingArchiveFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "160px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: buildingArchiveFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Buildings</option>
                        {uniqueArchiveBuildings.map(b => (
                          <option key={b.id} value={b.id}>{b.name}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {uniqueArchiveCerts.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: certArchiveFilter ? "#fff5f5" : "#f8f9fa",
                        border: certArchiveFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-award ${certArchiveFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={certArchiveFilter}
                        onChange={e => setArchiveCertFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "160px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: certArchiveFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Certificates</option>
                        {uniqueArchiveCerts.map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {uniqueArchiveDates.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 rounded-pill px-3 py-2 filter-item"
                      style={{
                        backgroundColor: dateArchiveFilter ? "#fff5f5" : "#f8f9fa",
                        border: dateArchiveFilter ? "1px solid #dc3545" : "1px solid transparent",
                        transition: "all 0.2s ease"
                      }}
                    >
                      <i className={`bi bi-calendar3 ${dateArchiveFilter ? 'text-danger' : 'text-muted'}`}></i>
                      <Form.Select
                        value={dateArchiveFilter}
                        onChange={e => setArchiveDateFilter(e.target.value)}
                        size="sm"
                        className="border-0 bg-transparent fw-medium"
                        style={{
                          width: "140px",
                          cursor: "pointer",
                          boxShadow: "none",
                          outline: "none",
                          color: dateArchiveFilter ? "#dc3545" : "inherit"
                        }}
                      >
                        <option value="">All Dates</option>
                        {uniqueArchiveDates.map(d => (
                          <option key={d.value} value={d.value}>{d.label}</option>
                        ))}
                      </Form.Select>
                    </div>
                  )}

                  {/* <div className="vr d-none d-lg-block" style={{ height: "50px" }}></div>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={handleOpenPresetModal}
                      className="rounded-pill px-3 py-2 fw-medium shadow-sm"
                    >
                      <i className="bi bi-gear-fill me-2"></i>
                      Presets
                    </Button> */}
                </div>
              )}

            </div>

            {viewMode === "review" && (buildingFilter || certFilter || dateFilter) && (
              <div className="d-flex flex-wrap align-items-center gap-2 mt-3 px-2">
                <small className="text-muted fw-medium">Filtered by:</small>

                {buildingFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-building"></i>
                    <span className="fw-medium">{uniqueBuildings.find(b => b.id === buildingFilter)?.name}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setBuildingFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                {certFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-award"></i>
                    <span className="fw-medium">{certFilter}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setCertFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                {dateFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-calendar3"></i>
                    <span className="fw-medium">{uniqueDates.find(d => d.value === dateFilter)?.label}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setDateFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                <Button
                  variant="link"
                  size="sm"
                  className="text-decoration-none text-danger fw-medium ms-1"
                  onClick={() => {
                    setBuildingFilter('');
                    setCertFilter('');
                    setDateFilter('');
                  }}
                >
                  Clear all
                </Button>
              </div>
            )}

            {viewMode === "finalReview" && (buildingFinalReviewFilter || certFinalReviewFilter || dateFinalReviewFilter) && (
              <div className="d-flex flex-wrap align-items-center gap-2 mt-3 px-2">
                <small className="text-muted fw-medium">Filtered by:</small>

                {buildingFinalReviewFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-building"></i>
                    <span className="fw-medium">{uniqueFinalReviewBuildings.find(b => b.id === buildingFinalReviewFilter)?.name}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setBuildingFinalReviewFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                {certFinalReviewFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-award"></i>
                    <span className="fw-medium">{certFinalReviewFilter}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setFinalReviewCertFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                {dateFinalReviewFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-calendar3"></i>
                    <span className="fw-medium">{uniqueFinalReviewDates.find(d => d.value === dateFinalReviewFilter)?.label}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setFinalReviewDateFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                <Button
                  variant="link"
                  size="sm"
                  className="text-decoration-none text-danger fw-medium ms-1"
                  onClick={() => {
                    setBuildingFinalReviewFilter('');
                    setFinalReviewCertFilter('');
                    setFinalReviewDateFilter('');
                  }}
                >
                  Clear all
                </Button>
              </div>
            )}

            {viewMode === "archive" && (buildingArchiveFilter || certArchiveFilter || dateArchiveFilter) && (
              <div className="d-flex flex-wrap align-items-center gap-2 mt-3 px-2">
                <small className="text-muted fw-medium">Filtered by:</small>

                {buildingArchiveFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-building"></i>
                    <span className="fw-medium">{uniqueArchiveBuildings.find(b => b.id === buildingArchiveFilter)?.name}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setBuildingArchiveFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                {certArchiveFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-award"></i>
                    <span className="fw-medium">{certArchiveFilter}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setArchiveCertFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                {dateArchiveFilter && (
                  <span
                    className="badge rounded-pill d-inline-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      padding: "0.5rem 0.75rem",
                      fontSize: "0.875rem",
                      boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
                    }}
                  >
                    <i className="bi bi-calendar3"></i>
                    <span className="fw-medium">{uniqueArchiveDates.find(d => d.value === dateArchiveFilter)?.label}</span>
                    <i
                      className="bi bi-x-circle-fill"
                      role="button"
                      onClick={() => setArchiveDateFilter('')}
                      style={{ cursor: "pointer", opacity: 0.8 }}
                      onMouseEnter={e => e.target.style.opacity = "1"}
                      onMouseLeave={e => e.target.style.opacity = "0.8"}
                    ></i>
                  </span>
                )}

                <Button
                  variant="link"
                  size="sm"
                  className="text-decoration-none text-danger fw-medium ms-1"
                  onClick={() => {
                    setBuildingArchiveFilter('');
                    setArchiveCertFilter('');
                    setArchiveDateFilter('');
                  }}
                >
                  Clear all
                </Button>
              </div>
            )}

          </div>

          <hr />
          <br />

          {viewMode === "review" && (
            loading ? (
              <div className="loading">Loading...</div>
            ) : filteredReports.length === 0 ? (
              <p className="text-center">
                {buildingFilter
                  ? `No reports found for this building`
                  : "No reports require review."
                }
              </p>
            ) : (
              <>
                <div className="row">
                  {paginatedReports.map((report) => {
                    const {
                      id,
                      buildingId,
                      doorLocation,
                      doorPullPhotoLink,
                      buildingName,
                    } = report;

                    return (
                      <div
                        className="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-4 position-relative" key={`${buildingId}_${id}`}
                      >
                        <div
                          className="card rounded-lg serviceCard position-relative"
                          data-aos-anchor-placement="center-bottom"
                          onClick={() => handleOpenModal(report)}
                        >
                          <button
                            className="btn btn-warning btn-sm position-absolute d-flex align-items-center justify-content-center"
                            style={{
                              top: "10px",
                              left: "10px",
                              zIndex: 2,
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                            }}
                            onClick={(e) => handleArchiveClick(e, report)}
                            title="Archive"
                          >
                            <FontAwesomeIcon icon={faArchive} color="white" />
                          </button>

                          <button
                            className="btn btn-danger btn-sm position-absolute d-flex align-items-center justify-content-center"
                            style={{
                              top: "10px",
                              right: "10px",
                              zIndex: 2,
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                            }}
                            onClick={(e) => handleDeleteClick(e, report)}
                            title="Delete"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>

                          <img
                            src={doorPullPhotoLink || defaultImage}
                            alt={doorLocation}
                            className="card-img-top rounded-top"
                            onLoad={() => {
                              setLoadedPageImages((previous) => previous + 1);
                            }}
                            onError={() => {
                              setLoadedPageImages((previous) => previous + 1);
                            }}
                          />

                          <div className="card-body text-center">
                            <h6 className="review-title">{doorLabel(report)}</h6>
                            <p className="review-level">
                              {buildingName || "Unknown"}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {showArchiveConfirmModal && (
                  <div
                    className="modal fade show d-flex align-items-center justify-content-center"
                    style={{
                      background: "rgba(0, 0, 0, 0.5)",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 100,
                    }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      style={{ maxWidth: "420px" }}
                    >
                      <div className="modal-content border-0 shadow-lg text-center">

                        <div className="modal-header border-0 pb-0">
                          <h5 className="modal-title w-100 fw-bold text-warning">Archive Report</h5>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowArchiveConfirmModal(false)}
                          ></button>
                        </div>

                        <div className="modal-body pt-2">
                          <p className="mb-3 text-muted">
                            This report will be archived and removed from review.
                          </p>

                          <div
                            className="p-2 rounded fw-semibold mx-auto"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              maxWidth: "80%",
                            }}
                          >
                            {selectedReport ? `${selectedReport.buildingName || "Unknown"} : ${doorLabel(selectedReport)}` : ""}
                          </div>
                        </div>

                        <div className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2">
                          <button
                            type="button"
                            className="btn btn-light px-4"
                            onClick={() => setShowArchiveConfirmModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-warning px-4 text-white"
                            onClick={handleConfirmArchive}
                          >
                            <FontAwesomeIcon icon={faArchive} className="me-2" />
                            Archive
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )
          )}

          {viewMode === "finalReview" && (
            loading ? (
              <div className="loading">Loading...</div>
            ) : filteredFinalReviewReports.length === 0 ? (
              <p className="text-center text-muted">No doors pending final review.</p>
            ) : (
              <>
                <div className="row">
                  {paginatedFinalReviewReports.map((report) => {
                    const {
                      id,
                      buildingId,
                      doorLocation,
                      doorPullPhotoLink,
                      buildingName,
                    } = report;

                    return (
                      <div
                        className="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-4 position-relative" key={`${buildingId}_${id}`}
                      >
                        <div
                          className="card rounded-lg serviceCard position-relative"
                          data-aos-anchor-placement="center-bottom"
                          onClick={() => handleOpenModal(report)}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              left: "10px",
                              zIndex: 2,
                              backgroundColor: "#0d6efd",
                              color: "white",
                              fontSize: "0.65rem",
                              fontWeight: "600",
                              padding: "2px 8px",
                              borderRadius: "20px",
                              letterSpacing: "0.05em",
                              textTransform: "uppercase",
                            }}
                          >
                            <i className="bi bi-check2-square me-1"></i>
                            Final Review
                          </div>
                          <div
                            className="position-absolute d-flex gap-2"
                            style={{
                              top: "10px",
                              right: "10px",
                              zIndex: 2,
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-warning btn-sm d-flex align-items-center justify-content-center"
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                              }}
                              disabled={archiveLoading}
                              onClick={(event) => handleSendBackClick(event, report)}
                              title="Send back to Review"
                              aria-label="Send back to Review"
                            >
                              <FontAwesomeIcon icon={faRotateLeft} />
                            </button>

                            <button
                              type="button"
                              className="btn btn-success btn-sm d-flex align-items-center justify-content-center"
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                              }}
                              disabled={archiveLoading}
                              onClick={(event) => handleFinalReviewConfirmClick(event, report)}
                              title="Confirm and Complete"
                              aria-label="Confirm and Complete"
                            >
                              <FontAwesomeIcon icon={faCheck} />
                            </button>
                          </div>

                          <img
                            src={doorPullPhotoLink || defaultImage}
                            alt={doorLocation}
                            className="card-img-top rounded-top"
                          />

                          <div className="card-body text-center">
                            <h6 className="review-title">{doorLabel(report)}</h6>
                            <p style={{ fontSize: "18px" }} className="review-level">
                              {buildingName || "Unknown"}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {showSendBackModal && (
                  <div
                    className="modal fade show d-flex align-items-center justify-content-center"
                    style={{
                      background: "rgba(0, 0, 0, 0.5)",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 1055,
                    }}
                    onClick={() => {
                      if (!archiveLoading) {
                        setShowSendBackModal(false);
                        setSelectedSendBackReport(null);
                      }
                    }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      style={{ maxWidth: "420px" }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <div className="modal-content border-0 shadow-lg text-center">
                        <div className="modal-header border-0 pb-0">
                          <h5 className="modal-title w-100 fw-bold text-warning">
                            Send Back to Review
                          </h5>

                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            disabled={archiveLoading}
                            onClick={() => {
                              setShowSendBackModal(false);
                              setSelectedSendBackReport(null);
                            }}
                          />
                        </div>

                        <div className="modal-body pt-2">
                          <p className="mb-3 text-muted">
                            This will remove the door from Final Review and send it back to the
                            Review section.
                          </p>

                          <div
                            className="p-2 rounded fw-semibold mx-auto"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              maxWidth: "80%",
                            }}
                          >
                            {selectedSendBackReport
                              ? `${selectedSendBackReport.buildingName || "Unknown"} : ${doorLabel(
                                selectedSendBackReport
                              )}`
                              : ""}
                          </div>
                        </div>

                        <div className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2">
                          <button
                            type="button"
                            className="btn btn-light px-4"
                            disabled={archiveLoading}
                            onClick={() => {
                              setShowSendBackModal(false);
                              setSelectedSendBackReport(null);
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            type="button"
                            className="btn btn-warning px-4"
                            disabled={archiveLoading}
                            onClick={handleConfirmSendBackToReview}
                          >
                            <FontAwesomeIcon icon={faRotateLeft} className="me-2" />

                            {archiveLoading ? "Sending..." : "Send Back"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {showFinalConfirmModal && (
                  <div
                    className="modal fade show d-flex align-items-center justify-content-center"
                    style={{
                      background: "rgba(0, 0, 0, 0.5)",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 100,
                    }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      style={{ maxWidth: "420px" }}
                    >
                      <div className="modal-content border-0 shadow-lg text-center">

                        <div className="modal-header border-0 pb-0">
                          <h5 className="modal-title w-100 fw-bold text-success">Confirm Completion</h5>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowFinalConfirmModal(false)}
                          ></button>
                        </div>

                        <div className="modal-body pt-2">
                          <p className="mb-3 text-muted">
                            This will mark the door as fully complete and remove it from Final Review.
                          </p>

                          <div
                            className="p-2 rounded fw-semibold mx-auto"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              maxWidth: "80%",
                            }}
                          >
                            {selectedFinalReport ? `${selectedFinalReport.buildingName || "Unknown"} : ${doorLabel(selectedFinalReport)}` : ""}
                          </div>
                        </div>

                        <div className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2">
                          <button
                            type="button"
                            className="btn btn-light px-4"
                            onClick={() => setShowFinalConfirmModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-success px-4"
                            onClick={handleConfirmFinalReview}
                          >
                            <FontAwesomeIcon icon={faCheck} className="me-2" />
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )
          )}

          {showDeleteModal && (
            <div
              className="modal fade show d-flex align-items-center justify-content-center"
              style={{
                background: "rgba(0, 0, 0, 0.5)",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 100,
              }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: "420px" }}
              >
                <div className="modal-content border-0 shadow-lg text-center">

                  <div className="modal-header border-0 pb-0">
                    <h5 className="modal-title w-100 fw-bold text-danger">Confirm Delete</h5>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => setShowDeleteModal(false)}
                    ></button>
                  </div>

                  <div className="modal-body pt-2">
                    <p className="mb-3 text-muted">
                      Are you sure you want to delete this door?
                    </p>

                    <div
                      className="p-2 rounded fw-semibold mx-auto"
                      style={{
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #dee2e6",
                        maxWidth: "80%",
                      }}
                    >
                      {selectedReport ? `${selectedReport.buildingName || "Unknown"} : ${doorLabel(selectedReport)}` : ""}
                    </div>
                  </div>

                  <div className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-light px-4"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger px-4"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}


          {viewMode === "archive" && (
            archiveLoading ? (
              <div className="loading">Loading...</div>
            ) : filteredArchiveReports.length === 0 ? (
              <p className="text-center text-muted">No archived reports.</p>
            ) : (
              <>
                <div className="row">
                  {paginatedArchiveReports.map((report) => {
                    const {
                      id,
                      buildingId,
                      doorLocation,
                      doorPullPhotoLink,
                      buildingName,
                    } = report;

                    return (
                      <div
                        className="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-4 position-relative"
                        key={`${buildingId}_${id}`}
                      >
                        <div
                          className="card rounded-lg serviceCard position-relative"
                          data-aos-anchor-placement="center-bottom"
                          style={{ opacity: 0.85 }}
                          onClick={() => handleOpenModal(report)}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              left: "10px",
                              zIndex: 2,
                              backgroundColor: "#6c757d",
                              color: "white",
                              fontSize: "0.65rem",
                              fontWeight: "600",
                              padding: "2px 8px",
                              borderRadius: "20px",
                              letterSpacing: "0.05em",
                              textTransform: "uppercase",
                            }}
                          >
                            <FontAwesomeIcon icon={faArchive} className="me-1" />
                            Archived
                          </div>

                          <button
                            className="btn btn-sm position-absolute d-flex align-items-center justify-content-center"
                            style={{
                              top: "10px",
                              right: "50px",
                              zIndex: 2,
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              backgroundColor: "white",
                            }}
                            onClick={(e) => handleUnarchiveClick(e, report)}
                            title="Restore to Review"
                          >
                            <FontAwesomeIcon icon={faUndo} style={{ fontSize: "0.75rem" }} />
                          </button>

                          <button
                            className="btn btn-danger btn-sm position-absolute d-flex align-items-center justify-content-center"
                            style={{
                              top: "10px",
                              right: "10px",
                              zIndex: 2,
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                            }}
                            onClick={(e) => handleDeleteClick(e, report)}
                            title="Delete"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>

                          <img
                            src={doorPullPhotoLink || defaultImage}
                            alt={doorLocation}
                            className="card-img-top rounded-top"
                            style={{ filter: "grayscale(20%)" }}
                          />

                          <div className="card-body text-center">
                            <h6 className="review-title">{doorLabel(report)}</h6>
                            <p className="review-level">
                              {buildingName || "Unknown"}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {showUnarchiveModal && (
                  <div
                    className="modal fade show d-flex align-items-center justify-content-center"
                    style={{
                      background: "rgba(0, 0, 0, 0.5)",
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 100,
                    }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      style={{ maxWidth: "420px" }}
                    >
                      <div className="modal-content border-0 shadow-lg text-center">

                        <div className="modal-header border-0 pb-0">
                          <h5 className="modal-title w-100 fw-bold text-success">Restore Report</h5>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowUnarchiveModal(false)}
                          ></button>
                        </div>

                        <div className="modal-body pt-2">
                          <p className="mb-3 text-muted">
                            This report will be restored to the review queue.
                          </p>

                          <div
                            className="p-2 rounded fw-semibold mx-auto"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              maxWidth: "80%",
                            }}
                          >
                            {selectedArchiveReport ? `${selectedArchiveReport.buildingName || "Unknown"} : ${doorLabel(selectedArchiveReport)}` : ""}
                          </div>
                        </div>

                        <div className="modal-footer border-0 pt-0 d-flex justify-content-center gap-2">
                          <button
                            type="button"
                            className="btn btn-light px-4"
                            onClick={() => setShowUnarchiveModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-success px-4"
                            onClick={handleConfirmUnarchive}
                          >
                            <i className="bi bi-arrow-counterclockwise me-2"></i>Restore
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )
          )}

        </>
      )}

      <Modal
        show={showModal}
        onHide={() => {
          setSubmitted(false);
          setUnlockedTabs('');
          setShowModal(false);
          openedKeyRef.current = null;
          goBack();
        }}
        size="xl"
        backdrop="static"
        centered
        className="p-0"
        enforceFocus={false}
        style={{ zIndex: 1055 }}
      >

        <Modal.Body className="p-4 bg-lightest">

          <Tabs
            id="door-tabs"
            className="modern-tabs mb-4"
            activeKey={activeTab}
            onSelect={(key) => {
              setSubmitted(false);
              setActiveTab(key);
              if (viewMode === "review") {
                runGapCheck();
                handleSubmit();
              }
            }}
          >

            <Tab
              eventKey="review"
              title={<span className={activeTab === 'review' ? 'tab-active' : 'tab-inactive'}>Review Report</span>}
            >
              {selectedReport && (
                <>
                  <Row className="mb-4">
                    <Col lg={8}>

                      <Card className="shadow-sm h-100">
                        <Card.Body>
                          <div className="media-strip d-flex gap-3 overflow-auto">
                            {mediaItems.map((item, index) => (
                              <div
                                key={item.key + index}
                                className="text-center flex-shrink-0"
                                style={{ width: 100, cursor: "pointer" }}
                                onClick={() => setActiveMedia({ open: true, index })}
                              >
                                <div className="media-box shadow-sm" style={{ width: "100%", height: 100, position: "relative" }}>
                                  {item.isVideo ? (
                                    <video
                                      src={item.src}
                                      muted
                                      autoPlay
                                      loop
                                      playsInline
                                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                  ) : (
                                    <img
                                      src={item.src}
                                      alt={item.label}
                                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                  )}
                                  {item.isVideo && (
                                    <div className="media-play-btn">
                                      <i className="bi bi-play-fill text-white fs-2"></i>
                                    </div>
                                  )}
                                </div>
                                <div className="media-label mt-1">{item.label}</div>
                              </div>
                            ))}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={4}>
                      <Card className="shadow-sm h-100">
                        <Card.Body style={{ overflowY: "auto" }}>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            style={{ resize: "none", fontSize: "14px" }}
                            value={formData.damageText || ""}
                            onChange={(e) =>
                              setFormData((prev) => ({ ...prev, damageText: e.target.value }))
                            }
                            placeholder="Enter damage notes here..."
                          />
                        </Card.Body>

                        <Card.Footer className="bg-white">
                          <div className="d-flex flex-wrap gap-2">
                            {[
                              { label: "Pull", photoKey: "doorPullPhotoLink", type: "pull", variant: "primary" },
                              { label: "Push", photoKey: "doorPushPhotoLink", type: "push", variant: "secondary" },
                              { label: "Hinge 1", photoKey: "hingePhotoLink", type: "hinge1", variant: "success" },
                              { label: "Hinge 2", photoKey: "hingePhotoLink2", type: "hinge2", variant: "success" },
                              { label: "Hinge 3", photoKey: "hingePhotoLink3", type: "hinge3", variant: "success" },
                            ]
                              .filter((btn) => selectedReport[btn.photoKey])
                              .map((btn, idx) => (
                                <Button
                                  key={idx}
                                  variant={btn.variant}
                                  size="sm"
                                  className="annotate-btn"
                                  onClick={() => handleOpenAnnotateModal(selectedReport, btn.type)}
                                >
                                  {btn.label}
                                </Button>
                              ))}
                          </div>
                        </Card.Footer>
                      </Card>
                    </Col>

                  </Row>

                  <Row className="g-4">
                    <Col md={8}>
                      <Card className="shadow-sm mb-4">
                        <Card.Body className="p-3">
                          <Row>
                            {[
                              {
                                key: "doorCloseAsIntented",
                                label: "Door Closes as Intended",
                                dropdown: ["Repair Door Closer", "Adjust Door Closer", "Install New Door Closer", "Replace Door Closer"],
                                allowNone: true
                              },
                              {
                                key: "doorStrips",
                                label: "Door Strips Present",
                                dropdown: ["Install Intumescent Strips", "Replace Damaged Intumescent Strip", "Replace Missing Intumescent Strip", "Intumescent Strip Installed Incorrectly"]
                              },
                              {
                                key: "hingesWorking",
                                label: "Hinges Working",
                                dropdown: ["Install Third Fire Rated Hinge", "Screws Missing From Hinge", "Loose Screws on Hinge", "Replace Broken Hinge"]
                              },
                              {
                                key: "hingesFireRating",
                                label: "Hinges Fire Rated",
                                dropdown: ["Replace Non-Compliant Hinge"]
                              },
                              {
                                key: "lockFireRated",
                                label: "Lock Fire Rated",
                                dropdown: ["Replace Non-Compliant Locks"],
                                allowNone: true
                              },
                              {
                                key: "keylessExit",
                                label: "Keyless Exit Present",
                                dropdown: ["Install Keyless Exit"],
                                allowNone: true
                              },
                              {
                                key: "letterBoxFireRated",
                                label: "LetterBox Fire Rated",
                                dropdown: ["Upgrade Non-Compliant LetterBox"],
                                allowNone: true
                              },
                              {
                                key: "relevantSignage",
                                label: "Relevant Signage Present",
                                dropdown: ["Install Relevant Signage"],
                              },
                            ].map(({ key, label, dropdown, allowNone }) => {
                              const value = formData[key] ?? null;
                              return (
                                <Col xs={12} md={6} key={key} className="mb-2">
                                  <div className="input-block">
                                    <label className="fw-bold mb-2">{label}</label>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                      <label
                                        className={`choice-box ${value === true ? 'choice-yes' : ''}`}
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '2px' }}
                                      >
                                        <input
                                          type="radio"
                                          name={key}
                                          checked={formData[key] === true}
                                          onChange={() => handleToggle(key, true)}
                                          style={{ margin: 0 }}
                                        />
                                        <span>Yes</span>
                                      </label>

                                      {allowNone && (
                                        <label
                                          className={`choice-box ${value === null ? 'choice-none' : ''}`}
                                          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '2px' }}
                                        >
                                          <input
                                            type="radio"
                                            name={key}
                                            checked={formData[key] === null}
                                            onChange={() => handleToggle(key, null)}
                                            style={{ margin: 0 }}
                                          />
                                          <span>None</span>
                                        </label>
                                      )}

                                      <label
                                        className={`choice-box ${value === false ? 'choice-no' : ''}`}
                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '2px' }}
                                      >
                                        <input
                                          type="radio"
                                          name={key}
                                          checked={formData[key] === false}
                                          onChange={() => handleToggle(key, false)}
                                          style={{ margin: 0 }}
                                        />
                                        <span>No</span>
                                      </label>

                                      {value === false && (
                                        <Form.Select
                                          value={dropdown.find((option) => formData.workNeeded.split(" | ").includes(option)) || ""}
                                          onChange={(e) => handleWorkNeededChange(key, e.target.value)}
                                          style={{ width: 120, height: 32, fontSize: '0.85rem', marginLeft: '4px' }}
                                          size="sm"
                                        >
                                          <option value="">Select Work</option>
                                          {dropdown.map((option, i) => (
                                            <option key={i} value={option}>{option}</option>
                                          ))}
                                        </Form.Select>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              )
                            })}
                          </Row>
                        </Card.Body>
                      </Card>

                      <Card className="shadow-sm mb-2">
                        <Card.Body className="p-3">
                          <div className="d-flex flex-column gap-3">
                            {[
                              { key: "door", label: "Door", dropdown: ["Replace Damaged Door", "Repair Damaged Door", "Replace Non-Compliant Door", "Other (Door)"], showNone: false },
                              { key: "frame", label: "Frame", dropdown: ["Repair Damaged Door Frame", "Replace damaged door frame", "Other (Frame)"], showNone: false },
                              { key: "glass", label: "Glass", dropdown: ["Replace Cracked Glass", "Replace Non-Compliant Glass", "Refix Loose Glazing Beads", "Replace Glazing Beads", "Other (Glass)"], showNone: true },
                              { key: "ventilation", label: "Ventilation Gaps", dropdown: ["Clear Blocked Ventilation Gaps", "Install Additional Gaps If Needed", "Other (Ventilation)"], showNone: true }
                            ].map(({ key, label, dropdown, showNone }) => {
                              const selectedValue = formData.damageMultiples[key] || `${label} Pass`;

                              return (
                                <div key={key} className="d-flex flex-wrap align-items-center gap-3 damage-line">
                                  <div
                                    style={{
                                      width: 100,
                                      fontWeight: 600,
                                      fontSize: key === "ventilation" ? "0.8rem" : "1rem",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis"
                                    }}
                                  >
                                    {label}
                                  </div>

                                  <div className={`choice-box ${selectedValue === `${label} Pass` ? "choice-yes" : ""}`} onClick={() => handleDamageSelection(`${label} Pass`, key)}>
                                    <input type="radio" name={key} checked={selectedValue === `${label} Pass`} onChange={() => handleDamageSelection(`${label} Pass`, key)} />
                                    <span>Pass</span>
                                  </div>

                                  {showNone && (
                                    <div className={`choice-box ${selectedValue === `${label} None` ? "choice-none" : ""}`} onClick={() => handleDamageSelection(`${label} None`, key)}>
                                      <input type="radio" name={key} checked={selectedValue === `${label} None`} onChange={() => handleDamageSelection(`${label} None`, key)} />
                                      <span>None</span>
                                    </div>
                                  )}

                                  <div className="d-flex align-items-center gap-2">
                                    <div className={`choice-box ${selectedValue === label ? "choice-no" : ""}`} onClick={() => handleDamageSelection(label, key)}>
                                      <input type="radio" name={key} checked={selectedValue === label} onChange={() => handleDamageSelection(label, key)} />
                                      <span>Fail</span>
                                    </div>

                                    {selectedValue === label && (
                                      <Form.Select
                                        size="sm"
                                        style={{ maxWidth: 150 }}
                                        value={dropdown.find((opt) => formData.workNeeded.split(" | ").includes(opt)) || ""}
                                        onChange={(e) => handleWorkNeededChange(key, e.target.value)}
                                      >
                                        <option value="">Select Work</option>
                                        {dropdown.map((opt, i) => (
                                          <option key={i} value={opt}>{opt}</option>
                                        ))}
                                      </Form.Select>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </Card.Body>
                      </Card>

                    </Col>

                    <Col lg={4}>
                      <Card className="shadow-sm mb-4">
                        <Card.Body className="p-3">
                          <Row className="mb-2">
                            <Col lg={4}>
                              <Form.Group className="mb-2">
                                <Form.Label className="fw-bold small mb-1">Door Level</Form.Label>
                                <Form.Select
                                  size="sm"
                                  value={formData.doorLevel || ""}
                                  onChange={(e) => handleInputChange("doorLevel", e.target.value)}
                                >
                                  <option value="">Select Door Level</option>

                                  {generateFloors().map((floor) => (
                                    <option key={floor} value={floor}>
                                      {floor}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            <Col lg={4}>
                              <Form.Group className="mb-2">
                                <Form.Label className="fw-bold small mb-1">Door Location</Form.Label>
                                <Form.Select
                                  size="sm"
                                  value={formData.doorLocation || ""}
                                  onChange={(e) => handleInputChange("doorLocation", e.target.value)}
                                >
                                  <option value="">Select Door Location</option>
                                  <option value="Flat Front Door">Flat Front Door</option>
                                  <option value="Communal Door">Communal Door</option>
                                  <option value="Store Cupboard">Store Cupboard</option>
                                  <option value="Corridor">Corridor</option>
                                  <option value="Water Meter Cupboard">Water Meter Cupboard</option>
                                  <option value="Water Shut Off Valve Cupboard">Water Shut Off Valve Cupboard</option>
                                  <option value="Electrical Meter Cupboard">Electrical Meter Cupboard</option>
                                  <option value="Buggy Store Door">Buggy Store Door</option>
                                  <option value="BT/Virgin Cupboard">BT/Virgin Cupboard</option>
                                  <option value="Car Park">Car Park</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group className="mb-0">
                                <Form.Label className="fw-bold small mb-1">Locks Needed</Form.Label>
                                <Form.Control
                                  type="text"
                                  size="sm"
                                  placeholder="Enter Locks Needed"
                                  value={formData.locksNeeded || ""}
                                  onChange={(e) => handleInputChange("locksNeeded", e.target.value)}
                                />
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group className="mb-0">
                                <Form.Label className="fw-bold small mb-1">Closer Type</Form.Label>
                                <Form.Select
                                  size="sm"
                                  value={formData.closerType || ""}
                                  onChange={(e) => handleInputChange("closerType", e.target.value)}
                                >
                                  <option value="">Select Closer Type</option>
                                  <option value="Overhead">Overhead</option>
                                  <option value="Internal">Internal</option>
                                  <option value="Chain Perko">Chain Perko</option>
                                  <option value="None">None</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>


                            <Col md={4}>
                              <Form.Group className="mb-0">
                                <Form.Label className="fw-bold small mb-1">Strip Type</Form.Label>
                                <Form.Select
                                  size="sm"
                                  value={formData.stripType || ""}
                                  onChange={(e) => handleInputChange("stripType", e.target.value)}
                                >
                                  <option value="">Select Strip Type</option>
                                  <option value="Intumescent Strip">Intumescent Strip</option>
                                  <option value="Smoke Strip">Smoke Strip</option>
                                  <option value="Both">Both</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>


                            {selectedReport.hasAccess === false && (
                              <Col md={4}>
                                <Form.Group className="mb-0">
                                  <Form.Label className="fw-bold small mb-1">
                                    No Access Reason
                                  </Form.Label>

                                  <Form.Control
                                    type="text"
                                    size="sm"
                                    placeholder="Enter No Access Reason"
                                    value={formData.noAccessReason || ""}
                                    onChange={(e) =>
                                      handleInputChange("noAccessReason", e.target.value)
                                    }
                                  />
                                </Form.Group>
                              </Col>
                            )}

                          </Row>

                          <Row>
                            <Col md={4}>
                              <Form.Group className="mb-0">
                                <Form.Label className="fw-bold small mb-1">Door Usage</Form.Label>
                                <Form.Select
                                  size="sm"
                                  value={formData.doorUsage || ""}
                                  onChange={(e) => handleInputChange("doorUsage", e.target.value)}
                                >
                                  <option value="">Select Door Usage</option>
                                  <option value="Low Usage">Low Usage</option>
                                  <option value="Medium Usage">Medium Usage</option>
                                  <option value="High Usage">High Usage</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group className="mb-0">
                                <Form.Label className="fw-bold small mb-1">Door Number</Form.Label>
                                <Form.Control
                                  type="text"
                                  size="sm"
                                  placeholder="Enter Door Number"
                                  value={formData.doorNumber || ""}
                                  onChange={(e) => handleInputChange("doorNumber", e.target.value)}
                                />
                              </Form.Group>
                            </Col>

                            <Col md={4}>
                              <Form.Group className="mb-0">
                                <Form.Label className="fw-bold small mb-1">Frame Material</Form.Label>
                                <Form.Select
                                  size="sm"
                                  value={formData.frameMaterial || "Wood"}
                                  onChange={(e) => handleInputChange("frameMaterial", e.target.value)}
                                >
                                  <option value="Wood">Wood</option>
                                  <option value="Steel">Steel</option>
                                  <option value="Aluminium">Aluminium</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>

                          </Row>

                        </Card.Body>
                      </Card>

                      <Card className="shadow-sm mb-4">
                        <Card.Body>
                          <label className="fw-bold mb-3">Door Certification</label>
                          <div className="d-flex flex-wrap gap-2">
                            {["FD30", "FD60", "Assumed", "No"].map(option => {
                              const isChecked = formData.doorCertif === option;
                              const isGreen = ["FD30", "FD60", "Assumed"].includes(option);
                              return (
                                <div
                                  key={option}
                                  className={`choice-box ${isChecked ? (isGreen ? 'choice-yes' : 'choice-no') : ''}`}
                                  onClick={() => handleToggle1("doorCertif", option)}
                                >
                                  <input
                                    type="radio"
                                    name="doorCertif"
                                    value={option}
                                    checked={formData.doorCertif === option}
                                    onChange={() => handleToggle1("doorCertif", option)}
                                    style={{ marginRight: 8 }}
                                  />
                                  <span>{option}</span>
                                </div>
                              )
                            })}
                          </div>
                        </Card.Body>
                      </Card>

                      <Card className="shadow-sm mb-4">
                        <Card.Body>
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <label className="fw-bold">Door Dimensions</label>
                          </div>
                          <div className="d-flex gap-3 align-items-center flex-wrap">
                            {[
                              { label: "W", key: "doorDimWidth" },
                              { label: "H", key: "doorDimHeight" },
                              { label: "D", key: "doorDimDepth" }
                            ].map(({ label, key }) => (
                              <div key={key} className="d-flex align-items-center gap-1">
                                <span className="fw-bold">{label}:</span>
                                <Form.Control
                                  type="text"
                                  placeholder={label}
                                  value={formData[key] || ""}
                                  onChange={(e) => handleInputChange(key, e.target.value)}
                                  style={{ width: 60, height: 32, padding: "0 6px", fontSize: "0.85rem" }}
                                  size="sm"
                                />
                              </div>
                            ))}
                          </div>
                        </Card.Body>
                      </Card>

                      <Card className="shadow-sm mb-12">
                        <Card.Body>
                          <h6 className="fw-bold mb-3">Gap Adjustments (mm)</h6>
                          <div className="d-flex gap-3 flex-wrap">
                            {[
                              { key: "fD1", label: "Lock" },
                              { key: "fD2", label: "Hinge" },
                              { key: "fD3", label: "Top" },
                              { key: "fD4", label: "Bottom" }
                            ].map(({ key, label }) => (
                              <div key={key} className="d-flex flex-column">
                                <Form.Label className="small mb-1">{label}</Form.Label>
                                <Form.Control
                                  type="number"
                                  min="0"
                                  value={formData[key] ?? ""}
                                  onChange={(e) => handleGapChange(key, parseInt(e.target.value, 10) || 0)}
                                  style={{ width: 60 }}
                                  size="sm"
                                />
                              </div>
                            ))}
                          </div>
                        </Card.Body>
                      </Card>

                    </Col>
                  </Row>

                </>
              )}
            </Tab>

            <Tab
              eventKey="editWorkReq"
              title={<span className={activeTab === 'editWorkReq' ? 'tab-active' : 'tab-inactive'}>Edit Work Required</span>}
            >
              <Col md={12}>
                <Card className="shadow-sm">
                  <Card.Header className="bg-light fw-bold py-3">Edit Work Required</Card.Header>
                  <Card.Body className="p-4">
                    <Form.Control
                      as="textarea"
                      // rows={12}
                      value={formData.workNeeded}
                      onChange={(e) => setFormData((prev) => ({ ...prev, workNeeded: e.target.value }))}
                      placeholder="Enter work requirements separated by | symbol. Example: Repair Door Closer | Adjust Door Closer | Replace Hinge"
                      style={{
                        maxHeight: '100px',
                        minHeight: '100px',
                        resize: 'none',
                        overflowY: 'auto',
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '0.9rem',
                        lineHeight: '1.5'
                      }}
                    />
                    <Alert variant="warning" className="mt-3">
                      <div className="d-flex align-items-start">
                        <i className="bi bi-info-circle me-2 mt-1"></i>
                        <div>
                          <strong>Format Tip:</strong> If entering multiple work items, separate them using <code>" | "</code>.
                          <br />
                          <small className="text-muted">Example: Screws Missing From Hinge | Adjust Door Closer | Replace Door Closer</small>
                        </div>
                      </div>
                    </Alert>
                  </Card.Body>
                </Card>
              </Col>
            </Tab>

          </Tabs>
        </Modal.Body>

        <Modal.Footer className="p-3 bg-white">
          {activeTab === "review" ? (
            <>
              {/* <div style={{ display: "flex", gap: 8, flexWrap: 'wrap' }}>
                <Button variant={selectedPreset === 0 ? "primary" : "outline-primary"} onClick={() => applyPreset(0)}>Default</Button>
                {Object.keys(presetData).map((id) => (
                  <Button key={id} variant={selectedPreset === id ? "primary" : "outline-primary"} onClick={() => applyPreset(id)}>Preset {id}</Button>
                ))}
              </div> */}

              <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                <Button variant="secondary" onClick={() => { setShowModal(false); openedKeyRef.current = null; goBack(); setSubmitted(false); setUnlockedTabs(""); }}>Cancel</Button>
                <Button
                  variant="success"
                  onClick={() => {
                    if (viewMode === "review") {
                      runGapCheck();
                      handleSubmit();
                    }
                    if (activeTab === "review") {
                      setActiveTab("editWorkReq");
                    }
                  }}
                >
                  Next
                </Button>
              </div>
            </>
          ) : (
            <>
              <Button variant="secondary" onClick={() => { setShowModal(false); openedKeyRef.current = null; goBack(); setSubmitted(false); setUnlockedTabs(""); }}>Cancel</Button>
              <Button variant="success" onClick={() => {
                handleSubmit();
                if (activeTab === "editWorkReq") {
                  saveFinalSubmit();
                }
              }}
              >
                Save Report
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {!directOpen && (
        <>
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={(value) => {
              if (pageLoading) return;

              setPageLoading(true);
              setLoadedPageImages(0);
              setItemsPerPage(value);

              setPages({
                review: 1,
                finalReview: 1,
                archive: 1,
              });
            }}
            totalCount={activeTotalCount}
            pageLoading={pageLoading}
          />

          <Modal show={!!zoomedImage || !!zoomedVideo} onHide={() => {
            setZoomedImage(null);
            setZoomedVideo(null);
          }} centered>
            <Modal.Body className="d-flex justify-content-center align-items-center p-0" style={{ maxHeight: "90vh" }}>
              {zoomedImage && (
                <img
                  src={zoomedImage}
                  alt="Zoomed"
                  className="img-fluid"
                  style={{ maxWidth: "100%", borderRadius: "8px" }}
                />
              )}

              {zoomedVideo && (
                <video
                  controls
                  autoPlay
                  muted
                  style={{
                    width: "100%",
                    maxHeight: "90vh",
                    borderRadius: "8px",
                  }}
                >
                  <source src={zoomedVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </Modal.Body>
          </Modal>

          <Modal
            show={showPresetModal}
            onHide={() => setShowPresetModal(false)}
            size="xl"
            centered
            dialogClassName="preset-modal-xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>Manage Presets</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Tabs
                activeKey={activePresetTab}
                onSelect={(k) => setPresetActiveTab(k)}
                className="mb-3"
                fill
                style={{ borderBottom: "3px solid red" }}
              >
                {[1, 2, 3].map((num) => (
                  <Tab eventKey={`${num}`} title={
                    <span
                      style={{
                        padding: "8px 16px",
                        borderRadius: "5px 5px 0 0",
                        backgroundColor: activePresetTab === `${num}` ? "red" : "#e9ecef",
                        color: activePresetTab === `${num}` ? "#fff" : "#333",
                        border: "1px solid #dee2e6",
                        borderBottom: activePresetTab === `${num}` ? "3px solid red" : "none",
                      }}
                    >
                      Preset {num}
                    </span>
                  }
                    key={num}>
                    <Card className="p-3 shadow-sm mt-2">
                      <h5 className="mb-3">Dimensions</h5>
                      <Row className="g-2">
                        {[
                          "doorDimWidth",
                          "doorDimHeight",
                          "doorDimDepth",
                          "doorCertif",
                        ].map((field) => (
                          <Col md={3} key={field}>
                            <Form.Group className="mb-2">
                              <Form.Label className="text-capitalize">{field}</Form.Label>
                              <Form.Control
                                value={presetData[num]?.[field] || ""}
                                onChange={(e) => handleFieldChange(num, field, e.target.value)}
                              />
                            </Form.Group>
                          </Col>
                        ))}

                        {[
                          {
                            field: "doorLevel",
                            label: "Door Level",
                            options: generateFloors(),
                          },
                          {
                            field: "doorLocation",
                            label: "Door Location",
                            options: [
                              "", "Flat Front Door", "Communal Door", "Store Cupboard", "Corridor",
                              "Water Meter Cupboard", "Water Shut Off Valve Cupboard",
                              "Electrical Meter Cupboard", "Buggy Store Door", "BT/Virgin Cupboard",
                              "Car Park",
                            ],
                          },
                          {
                            field: "doorUsage",
                            label: "Door Usage",
                            options: ["", "Low Usage", "Medium Usage", "High Usage"],
                          },
                        ].map(({ field, label, options }) => (
                          <Col md={3} key={field}>
                            <Form.Group className="mb-2">
                              <Form.Label>{label}</Form.Label>
                              <Form.Select
                                value={presetData[num]?.[field] || ""}
                                onChange={(e) => handleFieldChange(num, field, e.target.value)}
                              >
                                {options.map((opt) => (
                                  <option key={opt} value={opt}>
                                    {opt === "" ? `Select ${label}` : opt}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        ))}
                      </Row>

                      <hr />

                      <Row className="mb-3">
                        {["doorCloseAsIntented", "doorStrips", "hingesWorking", "hingesFireRating", "lockFireRated", "letterBoxFireRated", "keylessExit", "relevantSignage"].map((key) => {
                          const value = presetData[num]?.[key];
                          const options = key === "doorCloseAsIntented" ? [true, false, null] : [true, false];

                          const showDropdown = value === false;

                          return (
                            <Col md={6} className="mb-3" key={key}>
                              <Form.Group>
                                <Form.Label className="text-capitalize">{key}</Form.Label>
                                <div className="d-flex flex-wrap gap-2 align-items-center">
                                  {options.map((opt) => {
                                    const isSelected = value === opt;
                                    const bgColor = opt === true ? "#d4edda" : opt === false ? "#f8d7da" : "#e2e3e5";
                                    const label = opt === true ? "Yes" : opt === false ? "No" : "None";

                                    return (
                                      <div
                                        key={label}
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          cursor: "pointer",
                                          backgroundColor: isSelected ? bgColor : "#f9f9f9",
                                          borderRadius: "8px",
                                          padding: "10px 15px",
                                          border: "1px solid #ddd",
                                          minWidth: "80px",
                                          textAlign: "center",
                                        }}
                                        onClick={() => handleFieldChange(num, key, label)}
                                      >
                                        {label}
                                      </div>
                                    );
                                  })}

                                  {showDropdown && (
                                    <Form.Select
                                      size="sm"
                                      className="ms-2"
                                      value={presetData[num]?.workNeededSelections?.[key] || ""}
                                      onChange={(e) => handlePresetWorkNeededChange(num, key, e.target.value)}
                                    >
                                      <option value="" disabled>
                                        Select work needed...
                                      </option>
                                      {(fieldDropdowns[key] || []).map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  )}
                                </div>
                              </Form.Group>
                            </Col>
                          );
                        })}
                      </Row>

                      <hr />

                      <h5 className="mb-3">Damage Categories</h5>
                      <div className="row g-2 mb-3">
                        {[
                          { key: "door", label: "Door", dropdown: fieldDropdowns.door, allowNone: false },
                          { key: "frame", label: "Frame", dropdown: fieldDropdowns.frame, allowNone: false },
                          { key: "glass", label: "Glass", dropdown: fieldDropdowns.glass, allowNone: true },
                          { key: "ventilation", label: "Ventilation Gaps", dropdown: fieldDropdowns.ventilation, allowNone: true },
                        ].map(({ key, label, dropdown, allowNone }) => {
                          const currentValue = presetData[num]?.damageMultiples?.[key] || `${label} Pass`;
                          const states = ["Pass", "Fail"];
                          if (allowNone) states.push("None");

                          return (
                            <div className="col-md-6" key={key}>
                              <Card className="p-2 mb-2">
                                <div className="mb-1 fw-bold">{label}</div>

                                <div className="d-flex gap-2 flex-wrap mb-2">
                                  {states.map((stateOption) => {

                                    let isSelected = false;
                                    if (stateOption === "Fail") {
                                      isSelected = currentValue === label;
                                    } else if (stateOption === "None") {
                                      isSelected = currentValue === `${label} None`;
                                    } else {
                                      isSelected = currentValue === `${label} ${stateOption}`;
                                    }

                                    const bgColor =
                                      stateOption === "Pass"
                                        ? "#d4edda"
                                        : stateOption === "Fail"
                                          ? "#f8d7da"
                                          : "#e2e3e5";

                                    return (
                                      <div
                                        key={stateOption}
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          cursor: "pointer",
                                          backgroundColor: isSelected ? bgColor : "#f9f9f9",
                                          borderRadius: "8px",
                                          padding: "10px",
                                          border: "1px solid #ddd",
                                          minWidth: "70px",
                                          textAlign: "center",
                                        }}
                                        onClick={() =>
                                          setPresetData((prev) => ({
                                            ...prev,
                                            [num]: {
                                              ...prev[num],
                                              damageMultiples: {
                                                ...prev[num]?.damageMultiples,
                                                [key]:
                                                  stateOption === "Fail"
                                                    ? label
                                                    : stateOption === "None"
                                                      ? `${label} None`
                                                      : `${label} ${stateOption}`,
                                              },
                                              workNeededSelections: {
                                                ...prev[num]?.workNeededSelections,
                                                [key]:
                                                  stateOption === "Fail"
                                                    ? prev[num]?.workNeededSelections?.[key] || ""
                                                    : null,
                                              },
                                            },
                                          }))
                                        }
                                      >
                                        {stateOption}
                                      </div>
                                    );
                                  })}
                                </div>

                                {currentValue === label && (
                                  <Form.Select
                                    size="sm"
                                    value={presetData[num]?.workNeededSelections?.[key] || ""}
                                    onChange={(e) =>
                                      setPresetData((prev) => ({
                                        ...prev,
                                        [num]: {
                                          ...prev[num],
                                          workNeededSelections: {
                                            ...prev[num]?.workNeededSelections,
                                            [key]: e.target.value,
                                          },
                                        },
                                      }))
                                    }
                                  >
                                    <option value="" disabled>
                                      Select work needed...
                                    </option>
                                    {dropdown.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </Form.Select>
                                )}
                              </Card>
                            </div>
                          );
                        })}
                      </div>

                      <Button
                        variant="success"
                        className="mt-2 w-100"
                        onClick={() => handleSavePreset(num)}
                      >
                        Save Preset {num}
                      </Button>
                    </Card>
                  </Tab>
                ))}
              </Tabs>
            </Modal.Body>
          </Modal>

        </>
      )}

      {current && (
        <div className="media-modal-overlay">
          <div
            className="media-modal-container"
            onClick={(e) => e.stopPropagation()}
            style={{ width: "min(92vw, 1000px)", height: "min(85vh, 700px)" }}
          >
            <div
              className="image-viewer-container"
              style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
                borderRadius: 8,
                background: "#1a1a1a",
              }}
              onWheel={handleWheelZoom}
            >
              {current.isVideo ? (
                <video
                  ref={mediaRef}
                  src={current.src}
                  controls
                  muted
                  autoPlay
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
                    transition: isDragging ? "none" : "transform 0.1s ease-out",
                    transformOrigin: "center center",
                    cursor: zoom > 1 ? (isDragging ? "grabbing" : "grab") : "default",
                  }}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMoveDrag}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseLeaveMedia}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                  onDoubleClick={() => (zoom > 1 ? resetZoom() : setZoom(2))}
                />
              ) : (
                <img
                  ref={mediaRef}
                  src={current.src}
                  alt={current.label}
                  draggable={false}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
                    transition: isDragging ? "none" : "transform 0.1s ease-out",
                    transformOrigin: "center center",
                    cursor: zoom > 1 ? (isDragging ? "grabbing" : "grab") : "zoom-in",
                  }}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMoveDrag}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseLeaveMedia}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                  onDoubleClick={() => (zoom > 1 ? resetZoom() : setZoom(2))}
                />
              )}

              <div
                className="position-absolute bottom-0 end-0 d-flex gap-2 m-3"
                style={{ zIndex: 5 }}
              >
                <button
                  className="btn btn-sm rounded-circle"
                  onClick={zoomOutBtn}
                  style={{
                    background: "rgba(0,0,0,0.7)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    width: 36,
                    height: 36,
                    padding: 0,
                    color: "white",
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 12H4" />
                  </svg>
                </button>
                <span
                  className="px-3 rounded-pill d-flex align-items-center"
                  style={{
                    background: "rgba(0,0,0,0.7)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    color: "white",
                    fontSize: 13,
                    fontWeight: 500,
                  }}
                >
                  {Math.round(zoom * 100)}%
                </span>
                <button
                  className="btn btn-sm rounded-circle"
                  onClick={zoomInBtn}
                  style={{
                    background: "rgba(0,0,0,0.7)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    width: 36,
                    height: 36,
                    padding: 0,
                    color: "white",
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 4v16M20 12H4" />
                  </svg>
                </button>
                <button
                  className="btn btn-sm rounded-circle"
                  onClick={resetZoom}
                  title="Reset zoom"
                  style={{
                    background: "rgba(0,0,0,0.7)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    width: 36,
                    height: 36,
                    padding: 0,
                    color: "white",
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
              </div>

              {mediaItems.length > 1 && (
                <>
                  <button
                    className="btn position-absolute top-50 start-0 translate-middle-y ms-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigateMedia(-1);
                    }}
                    style={{
                      background: "rgba(0,0,0,0.5)",
                      backdropFilter: "blur(8px)",
                      border: "1px solid rgba(255,255,255,0.2)",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      padding: 0,
                      color: "white",
                      zIndex: 6,
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M15 18l-6-6 6-6" />
                    </svg>
                  </button>
                  <button
                    className="btn position-absolute top-50 end-0 translate-middle-y me-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigateMedia(1);
                    }}
                    style={{
                      background: "rgba(0,0,0,0.5)",
                      backdropFilter: "blur(8px)",
                      border: "1px solid rgba(255,255,255,0.2)",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      padding: 0,
                      color: "white",
                      zIndex: 6,
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                </>
              )}

              <div
                className="position-absolute top-0 start-0 end-0 d-flex justify-content-between align-items-center px-3 py-2"
                style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.6), transparent)", zIndex: 6 }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span style={{ color: "white", fontSize: 11, fontWeight: 600 }}>
                    {activeMedia.index + 1} / {mediaItems.length}
                  </span>
                  <span
                    className="px-2 py-0 rounded-pill"
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      backdropFilter: "blur(8px)",
                      color: "white",
                      fontSize: 9,
                      textTransform: "uppercase",
                    }}
                  >
                    {current.isVideo ? "Video" : "Photo"}
                  </span>
                  <span style={{ color: "rgba(255,255,255,0.8)", fontSize: 11 }}>{current.label}</span>
                </div>
                <button
                  className="btn btn-sm rounded-circle"
                  onClick={closeModal}
                  style={{
                    background: "rgba(0,0,0,0.5)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    width: 30,
                    height: 30,
                    padding: 0,
                    color: "white",
                    fontSize: 18,
                    lineHeight: 1,
                  }}
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div >
  );
};

export default Review;